import { unsafeCSS as D, LitElement as B, html as x, css as Se } from "lit";
import { property as h, customElement as z, state as V } from "lit/decorators.js";
import { unsafeSVG as q } from "lit/directives/unsafe-svg.js";
import { createRef as ae, ref as le } from "lit/directives/ref.js";
import { styleMap as We } from "lit/directives/style-map.js";
import { classMap as ee } from "lit/directives/class-map.js";
import { ifDefined as Y } from "lit/directives/if-defined.js";
const Le = '<?xml version="1.0" encoding="UTF-8"?><svg id="uuid-95ba2040-9ac0-475a-8922-8efb8e520dd9" xmlns="http://www.w3.org/2000/svg" width="16.1" height="12.6" viewBox="0 0 16.1 12.6"><g id="uuid-3e7e7f5b-c37c-4dcd-841e-ad0c3e043887"><path id="uuid-8957d556-51d2-4820-92a8-87d36b0086e8" d="m5.6,8.6L14.2,0l1.9,1.9L5.3,12.6,0,7.3l2.1-2.1,3.5,3.4Z" style="stroke-width:0px;"/></g></svg>', Xe = `@charset "UTF-8";.es_custom-checkbox{width:12px;height:12px;border:1px solid #d1d3d4;display:inline-flex;align-items:center;justify-content:center;vertical-align:middle}.es_custom-checkbox[data-disabled=true]{background-color:#f3f4f4}.es_custom-checkbox[data-checked=partially]:after{content:"";width:8px;height:8px;background-color:#d1d3d4;display:inline-block}.es_custom-checkbox[data-type=radio]{border-radius:50%}.es_custom-checkbox[data-type=radio][data-checked=checked]:after{border-radius:50%;background-color:#3c77bd;content:"";width:8px;height:8px}
`;
var Ge = Object.defineProperty, Ke = Object.getOwnPropertyDescriptor, de = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? Ke(t, o) : t, d = e.length - 1, c; d >= 0; d--)
    (c = e[d]) && (a = (r ? c(t, o, a) : c(a)) || a);
  return r && a && Ge(t, o, a), a;
};
let U = class extends B {
  constructor() {
    super(), this.checked = "empty", this.type = "checkbox", this.disabled = !1;
  }
  render() {
    return x`
        <div class="es_custom-checkbox" data-checked="${this.checked}" data-type="${this.type}" data-disabled="${this.disabled}">

            ${this.checked === "checked" && this.type === "checkbox" ? x`${q(Le)}` : null}
            
        </div>`;
  }
};
U.styles = D(Xe);
de([
  h()
], U.prototype, "checked", 2);
de([
  h()
], U.prototype, "type", 2);
de([
  h({ type: Boolean })
], U.prototype, "disabled", 2);
U = de([
  z("es-custom-checkbox")
], U);
const Ze = `@charset "UTF-8";.es_overlay-backdrop{position:fixed;top:0;left:0;right:0;bottom:0;z-index:1050}.es_overlay-backdrop.es_overlay-backdrop-transparent{background-color:transparent}.es_overlay-backdrop.es_overlay-backdrop-light{background-color:#ffffffbf}.es_overlay-backdrop.es_overlay-backdrop-dark{background-color:#00000040}.es_overlay{position:fixed;z-index:1060;box-sizing:border-box;display:flex;flex-direction:column;pointer-events:none}.es_overlay .es_overlay-pane{pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%;width:100%}
`;
var Je = Object.defineProperty, Qe = Object.getOwnPropertyDescriptor, T = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? Qe(t, o) : t, d = e.length - 1, c; d >= 0; d--)
    (c = e[d]) && (a = (r ? c(t, o, a) : c(a)) || a);
  return r && a && Je(t, o, a), a;
};
let S = class extends B {
  constructor() {
    super(...arguments), this._orientation = "down", this.backdropStyle = "dark", this.hasBackdrop = !0, this.overlayRef = ae(), this.show = !1;
  }
  get orientation() {
    return this._orientation;
  }
  set orientation(e) {
    this._orientation = e;
  }
  get originX() {
    return this._originX;
  }
  set originX(e) {
    this._originX = e;
  }
  get overlayStyles() {
    return We({ ...(() => {
      const t = this.getRelativeBoundingClientRect(this.connectedTo, this.positionRelativeTo);
      return t && this.connectedTo ? this.orientation === "down" ? this.originX == "start" ? {
        top: t.top + t.height - 1 + "px",
        left: t.left + "px",
        width: document.body.clientWidth - t.left + "px",
        minWidth: t.width + "px",
        height: window.innerHeight - t.top + "px"
      } : {
        top: t.top + t.height - 1 + "px",
        right: document.body.clientWidth - (t.left + t.width) + "px",
        width: document.body.clientWidth - (document.body.clientWidth - (t.left + t.width)) + "px",
        minWidth: t.width + "px",
        height: window.innerHeight - t.top + "px",
        alignItems: "end",
        justifyContent: "start"
      } : this.originX == "start" ? {
        bottom: window.innerHeight - t.top - 1 + "px",
        left: t.left + "px",
        minWidth: t.width + "px",
        width: document.body.clientWidth - t.left + "px",
        height: t.top + "px",
        alignItems: "start",
        justifyContent: "end"
      } : {
        bottom: window.innerHeight - t.top - 1 + "px",
        right: document.body.clientWidth - (t.left + t.width) + "px",
        minWidth: t.width + "px",
        width: document.body.clientWidth - (document.body.clientWidth - (t.left + t.width)) + "px",
        height: t.top + "px",
        alignItems: "end",
        justifyContent: "end"
      } : {};
    })(), ...this.overlaySize });
  }
  /** Fermer l'overlay. */
  close() {
    this.show = !1, this.dispatchEvent(new CustomEvent("close.es.overlay", { bubbles: !0, composed: !0 }));
  }
  /** Méthode du cycle du composant. */
  connectedCallback() {
    super.connectedCallback(), window.addEventListener("scroll", this.onWindowScrollHandle.bind(this)), window.addEventListener("resize", this.onWindowResizeHandle.bind(this));
  }
  /** Supprimer l'overlay */
  destroy() {
    this.remove();
  }
  /** Méthode du cycle du composant. */
  disconnectedCallback() {
    window.removeEventListener("scroll", this.onWindowScrollHandle.bind(this)), window.removeEventListener("resize", this.onWindowResizeHandle.bind(this)), super.disconnectedCallback();
  }
  /** Retourne le DOMRect calculé selon la présence d'un élément relatif de positionnement. */
  getRelativeBoundingClientRect(e, t) {
    if (e) {
      let o = e.getBoundingClientRect();
      if (!t)
        return o;
      let r = t.getBoundingClientRect();
      return new DOMRect(o.x - r.x, o.y - r.y, o.width, o.height);
    }
    return null;
  }
  /** Gestion de l'événement `click` sur le backdrop. */
  onBackdropClick() {
    this.close();
  }
  /** Gestion de l'événement `resize` de l'élément window. */
  onWindowResizeHandle() {
    this.position();
  }
  /** Gestion de l'événement `scroll` de l'élément window. */
  onWindowScrollHandle() {
    this.position();
  }
  /**
   * Mise à jour de la position de la superposition en fonction de l'orientation actuelle et
   * de l'origine.
   */
  position() {
    this.updateOrientation(), this.updateOriginX(), this.requestUpdate("overlayStyles");
  }
  /**
   * Mise à jour de l'orientation selon l'espace disponible.
   */
  updateOrientation() {
    let t = (() => {
      if (this.connectedTo) {
        const o = this.connectedTo.getBoundingClientRect(), r = o.top, a = window.innerHeight - o.bottom;
        return r > a ? "up" : "down";
      }
    })();
    t !== this.orientation && (this.orientation = t, this.dispatchEvent(new CustomEvent("orientationChange.es.overlay", { bubbles: !0, composed: !0, detail: this.orientation })));
  }
  /**
   * Si l'élément `connectedTo` est sur le côté gauche de l'écran, `originX` est défini sur "start",
   * sinon il est défini sur "end"
   */
  updateOriginX() {
    let t = (() => {
      if (this.connectedTo) {
        const o = this.connectedTo.getBoundingClientRect(), r = o.left, a = window.innerWidth - (r + o.width);
        return r > a ? "end" : "start";
      }
    })();
    this.originX !== t && (this.originX = t, this.dispatchEvent(new CustomEvent("originXChange.es.overlay", { bubbles: !0, composed: !0, detail: this.originX })));
  }
  /** Méthode de rendu du modèle. */
  render() {
    if (this.position(), this.show)
      return x`
            ${this.hasBackdrop ? x`<div class="es_overlay-backdrop es_overlay-backdrop-${this.backdropStyle}" @click=${this.onBackdropClick}></div>` : null}
            
            <div class="es_overlay" style=${this.overlayStyles} ${le(this.overlayRef)}>
                <div class="es_overlay-pane" @click=${(e) => e.stopPropagation()}>
                    <slot></slot>

                </div>
            </div>
        `;
  }
};
S.styles = D(Ze);
T([
  h()
], S.prototype, "backdropStyle", 2);
T([
  h()
], S.prototype, "connectedTo", 2);
T([
  h({ type: Boolean })
], S.prototype, "hasBackdrop", 2);
T([
  h()
], S.prototype, "overlaySize", 2);
T([
  h({ type: Object })
], S.prototype, "positionRelativeTo", 2);
T([
  h({ type: Boolean, reflect: !0 })
], S.prototype, "show", 2);
T([
  V()
], S.prototype, "orientation", 1);
T([
  V()
], S.prototype, "originX", 1);
T([
  V()
], S.prototype, "overlayStyles", 1);
S = T([
  z("es-overlay")
], S);
const Me = (e, t) => {
  const o = e[t];
  return o ? typeof o == "function" ? o() : Promise.resolve(o) : new Promise((r, a) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(a.bind(null, new Error("Unknown variable dynamic import: " + t)));
  });
};
(function() {
  const e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap(), w = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap(), k = /* @__PURE__ */ new WeakMap(), R = /* @__PURE__ */ new WeakMap(), W = /* @__PURE__ */ new WeakMap(), X = /* @__PURE__ */ new WeakMap(), G = /* @__PURE__ */ new WeakMap(), P = /* @__PURE__ */ new WeakMap(), H = {
    ariaAtomic: "aria-atomic",
    ariaAutoComplete: "aria-autocomplete",
    ariaBusy: "aria-busy",
    ariaChecked: "aria-checked",
    ariaColCount: "aria-colcount",
    ariaColIndex: "aria-colindex",
    ariaColIndexText: "aria-colindextext",
    ariaColSpan: "aria-colspan",
    ariaCurrent: "aria-current",
    ariaDisabled: "aria-disabled",
    ariaExpanded: "aria-expanded",
    ariaHasPopup: "aria-haspopup",
    ariaHidden: "aria-hidden",
    ariaInvalid: "aria-invalid",
    ariaKeyShortcuts: "aria-keyshortcuts",
    ariaLabel: "aria-label",
    ariaLevel: "aria-level",
    ariaLive: "aria-live",
    ariaModal: "aria-modal",
    ariaMultiLine: "aria-multiline",
    ariaMultiSelectable: "aria-multiselectable",
    ariaOrientation: "aria-orientation",
    ariaPlaceholder: "aria-placeholder",
    ariaPosInSet: "aria-posinset",
    ariaPressed: "aria-pressed",
    ariaReadOnly: "aria-readonly",
    ariaRelevant: "aria-relevant",
    ariaRequired: "aria-required",
    ariaRoleDescription: "aria-roledescription",
    ariaRowCount: "aria-rowcount",
    ariaRowIndex: "aria-rowindex",
    ariaRowIndexText: "aria-rowindextext",
    ariaRowSpan: "aria-rowspan",
    ariaSelected: "aria-selected",
    ariaSetSize: "aria-setsize",
    ariaSort: "aria-sort",
    ariaValueMax: "aria-valuemax",
    ariaValueMin: "aria-valuemin",
    ariaValueNow: "aria-valuenow",
    ariaValueText: "aria-valuetext",
    role: "role"
  }, te = (s, i) => {
    for (let n in H) {
      i[n] = null;
      let l = null;
      const u = H[n];
      Object.defineProperty(i, n, {
        get() {
          return l;
        },
        set(b) {
          l = b, s.isConnected ? s.setAttribute(u, b) : k.set(s, i);
        }
      });
    }
  };
  function K(s) {
    const i = r.get(s), { form: n } = i;
    we(s, n, i), ye(s, i.labels);
  }
  const Z = (s, i = !1) => {
    const n = document.createTreeWalker(s, NodeFilter.SHOW_ELEMENT, {
      acceptNode(b) {
        return r.has(b) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    let l = n.nextNode();
    const u = !i || s.disabled;
    for (; l; )
      l.formDisabledCallback && u && he(l, s.disabled), l = n.nextNode();
  }, J = { attributes: !0, attributeFilter: ["disabled", "name"] }, I = ne() ? new MutationObserver((s) => {
    for (const i of s) {
      const n = i.target;
      if (i.attributeName === "disabled" && (n.constructor.formAssociated ? he(n, n.hasAttribute("disabled")) : n.localName === "fieldset" && Z(n)), i.attributeName === "name" && n.constructor.formAssociated) {
        const l = r.get(n), u = v.get(n);
        l.setFormValue(u);
      }
    }
  }) : {};
  function $(s) {
    s.forEach((i) => {
      const { addedNodes: n, removedNodes: l } = i, u = Array.from(n), b = Array.from(l);
      u.forEach((p) => {
        var E;
        if (r.has(p) && p.constructor.formAssociated && K(p), k.has(p)) {
          const f = k.get(p);
          Object.keys(H).filter((M) => f[M] !== null).forEach((M) => {
            p.setAttribute(H[M], f[M]);
          }), k.delete(p);
        }
        if (P.has(p)) {
          const f = P.get(p);
          p.setAttribute("internals-valid", f.validity.valid.toString()), p.setAttribute("internals-invalid", (!f.validity.valid).toString()), p.setAttribute("aria-invalid", (!f.validity.valid).toString()), P.delete(p);
        }
        if (p.localName === "form") {
          const f = w.get(p), O = document.createTreeWalker(p, NodeFilter.SHOW_ELEMENT, {
            acceptNode(be) {
              return r.has(be) && be.constructor.formAssociated && !(f && f.has(be)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
            }
          });
          let M = O.nextNode();
          for (; M; )
            K(M), M = O.nextNode();
        }
        p.localName === "fieldset" && ((E = I.observe) == null || E.call(I, p, J), Z(p, !0));
      }), b.forEach((p) => {
        const E = r.get(p);
        E && o.get(E) && ge(E), c.has(p) && c.get(p).disconnect();
      });
    });
  }
  function Ie(s) {
    s.forEach((i) => {
      const { removedNodes: n } = i;
      n.forEach((l) => {
        const u = X.get(i.target);
        r.has(l) && Ee(l), u.disconnect();
      });
    });
  }
  const $e = (s) => {
    var n;
    const i = new MutationObserver(Ie);
    (n = i.observe) == null || n.call(i, s, { childList: !0 }), X.set(s, i);
  };
  ne() && new MutationObserver($);
  const ue = {
    childList: !0,
    subtree: !0
  }, he = (s, i) => {
    s.toggleAttribute("internals-disabled", i), i ? s.setAttribute("aria-disabled", "true") : s.removeAttribute("aria-disabled"), s.formDisabledCallback && s.formDisabledCallback.apply(s, [i]);
  }, ge = (s) => {
    o.get(s).forEach((n) => {
      n.remove();
    }), o.set(s, []);
  }, ve = (s, i) => {
    const n = document.createElement("input");
    return n.type = "hidden", n.name = s.getAttribute("name"), s.after(n), o.get(i).push(n), n;
  }, Ae = (s, i) => {
    var n;
    o.set(i, []), (n = I.observe) == null || n.call(I, s, J);
  }, ye = (s, i) => {
    if (i.length) {
      Array.from(i).forEach((l) => l.addEventListener("click", s.click.bind(s)));
      let n = i[0].id;
      i[0].id || (n = `${i[0].htmlFor}_Label`, i[0].id = n), s.setAttribute("aria-labelledby", n);
    }
  }, ie = (s) => {
    const i = Array.from(s.elements).filter((b) => !b.tagName.includes("-") && b.validity).map((b) => b.validity.valid), n = w.get(s) || [], l = Array.from(n).filter((b) => b.isConnected).map((b) => r.get(b).validity.valid), u = [...i, ...l].includes(!1);
    s.toggleAttribute("internals-invalid", u), s.toggleAttribute("internals-valid", !u);
  }, Oe = (s) => {
    ie(oe(s.target));
  }, Ve = (s) => {
    ie(oe(s.target));
  }, je = (s) => {
    const i = ["button[type=submit]", "input[type=submit]", "button:not([type])"].map((n) => `${n}:not([disabled])`).map((n) => `${n}:not([form])${s.id ? `,${n}[form='${s.id}']` : ""}`).join(",");
    s.addEventListener("click", (n) => {
      if (n.target.closest(i)) {
        const u = w.get(s);
        if (s.noValidate)
          return;
        u.size && Array.from(u).reverse().map((E) => r.get(E).reportValidity()).includes(!1) && n.preventDefault();
      }
    });
  }, Re = (s) => {
    const i = w.get(s.target);
    i && i.size && i.forEach((n) => {
      n.constructor.formAssociated && n.formResetCallback && n.formResetCallback.apply(n);
    });
  }, we = (s, i, n) => {
    if (i) {
      const l = w.get(i);
      if (l)
        l.add(s);
      else {
        const u = /* @__PURE__ */ new Set();
        u.add(s), w.set(i, u), je(i), i.addEventListener("reset", Re), i.addEventListener("input", Oe), i.addEventListener("change", Ve);
      }
      d.set(i, { ref: s, internals: n }), s.constructor.formAssociated && s.formAssociatedCallback && setTimeout(() => {
        s.formAssociatedCallback.apply(s, [i]);
      }, 0), ie(i);
    }
  }, oe = (s) => {
    let i = s.parentNode;
    return i && i.tagName !== "FORM" && (i = oe(i)), i;
  }, A = (s, i, n = DOMException) => {
    if (!s.constructor.formAssociated)
      throw new n(i);
  }, xe = (s, i, n) => {
    const l = w.get(s);
    return l && l.size && l.forEach((u) => {
      r.get(u)[n]() || (i = !1);
    }), i;
  }, Ee = (s) => {
    if (s.constructor.formAssociated) {
      const i = r.get(s), { labels: n, form: l } = i;
      ye(s, n), we(s, l, i);
    }
  };
  function ne() {
    return typeof MutationObserver < "u";
  }
  class Pe {
    constructor() {
      this.badInput = !1, this.customError = !1, this.patternMismatch = !1, this.rangeOverflow = !1, this.rangeUnderflow = !1, this.stepMismatch = !1, this.tooLong = !1, this.tooShort = !1, this.typeMismatch = !1, this.valid = !0, this.valueMissing = !1, Object.seal(this);
    }
  }
  const He = (s) => (s.badInput = !1, s.customError = !1, s.patternMismatch = !1, s.rangeOverflow = !1, s.rangeUnderflow = !1, s.stepMismatch = !1, s.tooLong = !1, s.tooShort = !1, s.typeMismatch = !1, s.valid = !0, s.valueMissing = !1, s), qe = (s, i, n) => (s.valid = De(i), Object.keys(i).forEach((l) => s[l] = i[l]), n && ie(n), s), De = (s) => {
    let i = !0;
    for (let n in s)
      n !== "valid" && s[n] !== !1 && (i = !1);
    return i;
  }, pe = /* @__PURE__ */ new WeakMap();
  function _e(s, i) {
    s.toggleAttribute(i, !0), s.part && s.part.add(i);
  }
  class se extends Set {
    static get isPolyfilled() {
      return !0;
    }
    constructor(i) {
      if (super(), !i || !i.tagName || i.tagName.indexOf("-") === -1)
        throw new TypeError("Illegal constructor");
      pe.set(this, i);
    }
    add(i) {
      if (!/^--/.test(i) || typeof i != "string")
        throw new DOMException(`Failed to execute 'add' on 'CustomStateSet': The specified value ${i} must start with '--'.`);
      const n = super.add(i), l = pe.get(this), u = `state${i}`;
      return l.isConnected ? _e(l, u) : setTimeout(() => {
        _e(l, u);
      }), n;
    }
    clear() {
      for (let [i] of this.entries())
        this.delete(i);
      super.clear();
    }
    delete(i) {
      const n = super.delete(i), l = pe.get(this);
      return l.isConnected ? (l.toggleAttribute(`state${i}`, !1), l.part && l.part.remove(`state${i}`)) : setTimeout(() => {
        l.toggleAttribute(`state${i}`, !1), l.part && l.part.remove(`state${i}`);
      }), n;
    }
  }
  function ke(s, i, n, l) {
    if (n === "a" && !l)
      throw new TypeError("Private accessor was defined without a getter");
    if (typeof i == "function" ? s !== i || !l : !i.has(s))
      throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return n === "m" ? l : n === "a" ? l.call(s) : l ? l.value : i.get(s);
  }
  function Be(s, i, n, l, u) {
    if (l === "m")
      throw new TypeError("Private method is not writable");
    if (l === "a" && !u)
      throw new TypeError("Private accessor was defined without a setter");
    if (typeof i == "function" ? s !== i || !u : !i.has(s))
      throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return l === "a" ? u.call(s, n) : u ? u.value = n : i.set(s, n), n;
  }
  var Q;
  class ze {
    constructor(i) {
      Q.set(this, void 0), Be(this, Q, i, "f");
      for (let n = 0; n < i.length; n++) {
        let l = i[n];
        this[n] = l, l.hasAttribute("name") && (this[l.getAttribute("name")] = l);
      }
      Object.freeze(this);
    }
    get length() {
      return ke(this, Q, "f").length;
    }
    [(Q = /* @__PURE__ */ new WeakMap(), Symbol.iterator)]() {
      return ke(this, Q, "f")[Symbol.iterator]();
    }
    item(i) {
      return this[i] == null ? null : this[i];
    }
    namedItem(i) {
      return this[i] == null ? null : this[i];
    }
  }
  function Ue() {
    const s = HTMLFormElement.prototype.checkValidity;
    HTMLFormElement.prototype.checkValidity = n;
    const i = HTMLFormElement.prototype.reportValidity;
    HTMLFormElement.prototype.reportValidity = l;
    function n(...b) {
      let p = s.apply(this, b);
      return xe(this, p, "checkValidity");
    }
    function l(...b) {
      let p = i.apply(this, b);
      return xe(this, p, "reportValidity");
    }
    const { get: u } = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "elements");
    Object.defineProperty(HTMLFormElement.prototype, "elements", {
      get(...b) {
        const p = u.call(this, ...b), E = Array.from(w.get(this) || []);
        if (E.length === 0)
          return p;
        const f = Array.from(p).concat(E).sort((O, M) => O.compareDocumentPosition ? O.compareDocumentPosition(M) & 2 ? 1 : -1 : 0);
        return new ze(f);
      }
    });
  }
  class Ce {
    static get isPolyfilled() {
      return !0;
    }
    constructor(i) {
      if (!i || !i.tagName || i.tagName.indexOf("-") === -1)
        throw new TypeError("Illegal constructor");
      const n = i.getRootNode(), l = new Pe();
      this.states = new se(i), e.set(this, i), t.set(this, l), r.set(i, this), te(i, this), Ae(i, this), Object.seal(this), n instanceof DocumentFragment && $e(n);
    }
    checkValidity() {
      const i = e.get(this);
      if (A(i, "Failed to execute 'checkValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
        return !0;
      const n = t.get(this);
      if (!n.valid) {
        const l = new Event("invalid", {
          bubbles: !1,
          cancelable: !0,
          composed: !1
        });
        i.dispatchEvent(l);
      }
      return n.valid;
    }
    get form() {
      const i = e.get(this);
      A(i, "Failed to read the 'form' property from 'ElementInternals': The target element is not a form-associated custom element.");
      let n;
      return i.constructor.formAssociated === !0 && (n = oe(i)), n;
    }
    get labels() {
      const i = e.get(this);
      A(i, "Failed to read the 'labels' property from 'ElementInternals': The target element is not a form-associated custom element.");
      const n = i.getAttribute("id"), l = i.getRootNode();
      return l && n ? l.querySelectorAll(`[for="${n}"]`) : [];
    }
    reportValidity() {
      const i = e.get(this);
      if (A(i, "Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
        return !0;
      const n = this.checkValidity(), l = W.get(this);
      if (l && !i.constructor.formAssociated)
        throw new DOMException("Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element.");
      return !n && l && (i.focus(), l.focus()), n;
    }
    setFormValue(i) {
      const n = e.get(this);
      if (A(n, "Failed to execute 'setFormValue' on 'ElementInternals': The target element is not a form-associated custom element."), ge(this), i != null && !(i instanceof FormData)) {
        if (n.getAttribute("name")) {
          const l = ve(n, this);
          l.value = i;
        }
      } else
        i != null && i instanceof FormData && Array.from(i).reverse().forEach(([l, u]) => {
          if (typeof u == "string") {
            const b = ve(n, this);
            b.name = l, b.value = u;
          }
        });
      v.set(n, i);
    }
    setValidity(i, n, l) {
      const u = e.get(this);
      if (A(u, "Failed to execute 'setValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !i)
        throw new TypeError("Failed to execute 'setValidity' on 'ElementInternals': 1 argument required, but only 0 present.");
      W.set(this, l);
      const b = t.get(this), p = {};
      for (const O in i)
        p[O] = i[O];
      Object.keys(p).length === 0 && He(b);
      const E = { ...b, ...p };
      delete E.valid;
      const { valid: f } = qe(b, E, this.form);
      if (!f && !n)
        throw new DOMException("Failed to execute 'setValidity' on 'ElementInternals': The second argument should not be empty if one or more flags in the first argument are true.");
      a.set(this, f ? "" : n), u.isConnected ? (u.toggleAttribute("internals-invalid", !f), u.toggleAttribute("internals-valid", f), u.setAttribute("aria-invalid", `${!f}`)) : P.set(u, this);
    }
    get shadowRoot() {
      const i = e.get(this), n = R.get(i);
      return n || null;
    }
    get validationMessage() {
      const i = e.get(this);
      return A(i, "Failed to read the 'validationMessage' property from 'ElementInternals': The target element is not a form-associated custom element."), a.get(this);
    }
    get validity() {
      const i = e.get(this);
      return A(i, "Failed to read the 'validity' property from 'ElementInternals': The target element is not a form-associated custom element."), t.get(this);
    }
    get willValidate() {
      const i = e.get(this);
      return A(i, "Failed to read the 'willValidate' property from 'ElementInternals': The target element is not a form-associated custom element."), !(i.disabled || i.hasAttribute("disabled") || i.hasAttribute("readonly"));
    }
  }
  function Ne() {
    if (typeof window > "u" || !window.ElementInternals || !HTMLElement.prototype.attachInternals)
      return !1;
    class s extends HTMLElement {
      constructor() {
        super(), this.internals = this.attachInternals();
      }
    }
    const i = `element-internals-feature-detection-${Math.random().toString(36).replace(/[^a-z]+/g, "")}`;
    customElements.define(i, s);
    const n = new s();
    return [
      "shadowRoot",
      "form",
      "willValidate",
      "validity",
      "validationMessage",
      "labels",
      "setFormValue",
      "setValidity",
      "checkValidity",
      "reportValidity"
    ].every((l) => l in n.internals);
  }
  if (Ne()) {
    if (typeof window < "u" && !window.CustomStateSet) {
      window.CustomStateSet = se;
      const s = HTMLElement.prototype.attachInternals;
      HTMLElement.prototype.attachInternals = function(...i) {
        const n = s.call(this, i);
        return n.states = new se(this), n;
      };
    }
  } else {
    if (typeof window < "u" && (window.ElementInternals = Ce), typeof CustomElementRegistry < "u") {
      const s = CustomElementRegistry.prototype.define;
      CustomElementRegistry.prototype.define = function(i, n, l) {
        if (n.formAssociated) {
          const u = n.prototype.connectedCallback;
          n.prototype.connectedCallback = function() {
            G.has(this) || (G.set(this, !0), this.hasAttribute("disabled") && he(this, !0)), u != null && u.apply(this), Ee(this);
          };
        }
        s.call(this, i, n, l);
      };
    }
    if (typeof HTMLElement < "u" && (HTMLElement.prototype.attachInternals = function() {
      if (this.tagName) {
        if (this.tagName.indexOf("-") === -1)
          throw new Error("Failed to execute 'attachInternals' on 'HTMLElement': Unable to attach ElementInternals to non-custom elements.");
      } else
        return {};
      if (r.has(this))
        throw new DOMException("DOMException: Failed to execute 'attachInternals' on 'HTMLElement': ElementInternals for the specified element was already attached.");
      return new Ce(this);
    }), typeof Element < "u") {
      let s = function(...n) {
        const l = i.apply(this, n);
        if (R.set(this, l), ne()) {
          const u = new MutationObserver($);
          window.ShadyDOM ? u.observe(this, ue) : u.observe(l, ue), c.set(this, u);
        }
        return l;
      };
      const i = Element.prototype.attachShadow;
      Element.prototype.attachShadow = s;
    }
    ne() && typeof document < "u" && new MutationObserver($).observe(document.documentElement, ue), typeof HTMLFormElement < "u" && Ue(), typeof window < "u" && !window.CustomStateSet && (window.CustomStateSet = se);
  }
})();
const Ye = '<?xml version="1.0" encoding="UTF-8"?><svg id="uuid-2f3490c6-00bf-4c7d-9e60-2a0f990a0c32" xmlns="http://www.w3.org/2000/svg" width="11.06" height="11.06" viewBox="0 0 11.06 11.06"><g id="uuid-221b49a8-2c0d-4e99-8b65-f8741820873d"><g id="uuid-9f780754-ef43-4a78-8eee-a93682959a66"><rect x="-1.54" y="4.78" width="14.14" height="1.5" transform="translate(-2.29 5.53) rotate(-45)" style="stroke-width:0px;"/><rect x="4.78" y="-1.54" width="1.5" height="14.14" transform="translate(-2.29 5.53) rotate(-45)" style="stroke-width:0px;"/></g></g></svg>', et = `@charset "UTF-8";:host([data-focused=true]){border:1px solid #3c77bd}:host([data-focused=true]) ::slotted(input){outline:none}:host([disabled]) .es_tags-input{background-color:#f3f4f4}:host([disabled]) ::slotted(input){background-color:transparent}:host{display:block;min-height:35px;border:1px solid #ced4da;padding:.25rem;border-radius:.25rem}:host ::slotted(input){border:1px solid transparent;flex:1}:host ::slotted(input):focus{color:#505154;background-color:#fff;border-color:#3c77bd;outline:0;box-shadow:"none"}:host .es_tags-input-tags-list{display:flex;flex-wrap:wrap}:host .es_tags-input-tags-list button{margin-right:.5rem;display:inline-block;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;-webkit-user-select:none;user-select:none;border:1px solid transparent;padding:.25rem .5rem;font-size:.8125rem;line-height:1.5;border-radius:.2rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;color:#505154;background-color:#f8f9fa;border-color:#f8f9fa}@media screen and (prefers-reduced-motion: reduce){:host .es_tags-input-tags-list button{transition:none}}:host .es_tags-input-tags-list button:hover,:host .es_tags-input-tags-list button:focus{text-decoration:none}:host .es_tags-input-tags-list button:focus,:host .es_tags-input-tags-list button.focus{outline:0;box-shadow:0 0 0 .2rem #3c77bd40}:host .es_tags-input-tags-list button.disabled,:host .es_tags-input-tags-list button:disabled{opacity:.65}:host .es_tags-input-tags-list button:not(:disabled):not(.disabled){cursor:pointer}:host .es_tags-input-tags-list button:not(:disabled):not(.disabled):active,:host .es_tags-input-tags-list button:not(:disabled):not(.disabled).active{background-image:none}:host .es_tags-input-tags-list button:hover{color:#505154;background-color:#fff;border-color:#d1d3d4}:host .es_tags-input-tags-list button:focus,:host .es_tags-input-tags-list button.focus{box-shadow:0 0 0 .2rem #d1d3d480}:host .es_tags-input-tags-list button.disabled,:host .es_tags-input-tags-list button:disabled{color:#505154;background-color:#f8f9fa;border-color:#f8f9fa}:host .es_tags-input-tags-list button:not(:disabled):not(.disabled):active,:host .es_tags-input-tags-list button:not(:disabled):not(.disabled).active,.show>:host .es_tags-input-tags-list button.dropdown-toggle{color:#505154;background-color:#dae0e5;border-color:#d3d9df}:host .es_tags-input-tags-list button:not(:disabled):not(.disabled):active:focus,:host .es_tags-input-tags-list button:not(:disabled):not(.disabled).active:focus,.show>:host .es_tags-input-tags-list button.dropdown-toggle:focus{box-shadow:0 0 0 .2rem #f8f9fa80}:host .es_tags-input-tags-list button svg{width:8px;height:8px}
`;
var tt = Object.defineProperty, it = Object.getOwnPropertyDescriptor, F = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? it(t, o) : t, d = e.length - 1, c; d >= 0; d--)
    (c = e[d]) && (a = (r ? c(t, o, a) : c(a)) || a);
  return r && a && tt(t, o, a), a;
};
let C = class extends B {
  constructor() {
    super(), this.icons = {
      closeSm: Ye
    }, this._disabled = !1, this._initialValue = [], this._value = [], this.focused = !1, this.separator = ";", this.tabindex = "0", this.unique = !1, this._validateTag = () => !0, this.addEventListener("focus", () => {
      var t;
      const e = ((t = this.shadowRoot) == null ? void 0 : t.querySelector("button")) || this.input;
      e == null || e.focus();
    }), this._internals = this.attachInternals();
  }
  get disabled() {
    return this._disabled;
  }
  set disabled(e) {
    this._disabled = e, this.syncInputDisabledStatus(), this.requestUpdate("disabled");
  }
  get value() {
    return this._value;
  }
  set value(e) {
    let t = this._value;
    this._value = e, this.requestUpdate("value", t), this.updateFormValue();
  }
  // Les propriétés et méthodes suivantes ne sont pas strictement requises,
  // mais les contrôles de formulaire au niveau du navigateur les fournissent. Les fournir permet
  // d'assurer la cohérence avec les contrôles fournis par le navigateur.
  /**
   * Récupère le formulaire parent associé à l'élément.
   * @return {HTMLFormElement | null} Le formulaire parent associé à l'élément.
   */
  get form() {
    return this._internals.form;
  }
  /**
   * Récupère le type de l'élément.
   * @return {string} Le type de l'élément.
   */
  get type() {
    return this.localName;
  }
  /**
   * Récupère le message de validation de l'élément.
   * @return {string} Le message de validation de l'élément.
   */
  get validationMessage() {
    return this._internals.validationMessage;
  }
  /**
   * Récupère l'état de validité de l'élément.
   * @return {ValidityState} L'état de validité de l'élément.
   */
  get validity() {
    return this._internals.validity;
  }
  /**
   * Indique si l'élément va être validé lors de la soumission du formulaire.
   * @return {boolean} true si l'élément va être validé, false sinon.
   */
  get willValidate() {
    return this._internals.willValidate;
  }
  /**
   * Ajoute un tag à la liste des tags.
   * @param {string} tag - Le tag à ajouter.
   * @emits {CustomEvent} add - Événement émis lors de l'ajout d'un tag. L'événement contient le tag ajouté dans sa propriété `detail` et peut être annulé.
   */
  async addTag(e) {
    e = e.trim(), !this.dispatchCustomEvent("add", { detail: e, cancelable: !0 }).defaultPrevented && e && await this.validateTag(e) && (this.unique ? this.value.includes(e) || this.value.push(e) : this.value.push(e), this.requestUpdate("value"), this.updateFormValue());
  }
  /**
   * Vérifie la validité de l'élément.
   * @returns {boolean} - Renvoie true si l'élément est valide, sinon false.
   */
  checkValidity() {
    return this._internals.checkValidity();
  }
  /**
   * Vide la valeur courante en supprimant tous les tags.
   */
  clear() {
    this.dispatchCustomEvent("clear", { cancelable: !0 }).defaultPrevented || (this.value = []);
  }
  /**
   * Méthode appelée lorsque l'élément est connecté au DOM.
   * Effectue les initialisations nécessaires et configure les écouteurs d'événements.
   * @override
   */
  connectedCallback() {
    super.connectedCallback(), this.input = this.querySelector("input"), this.input ? (this.input.addEventListener("focus", this.onInputFocus.bind(this)), this.input.addEventListener("blur", this.onInputBlur.bind(this)), this.syncInputDisabledStatus()) : console.warn("No input found. Please add an input field.", this), this._initialValue = [...this.value], this.updateFormValue(!1), this.dispatchCustomEvent("connected");
  }
  /**
   * Méthode appelée lorsque l'élément est déconnecté du DOM.
   * Supprime les écouteurs d'événements et effectue les nettoyages nécessaires.
   * @override
   */
  disconnectedCallback() {
    var e, t;
    (e = this.input) == null || e.removeEventListener("focus", this.onInputFocus.bind(this)), (t = this.input) == null || t.removeEventListener("blur", this.onInputBlur.bind(this)), super.disconnectedCallback(), this.dispatchCustomEvent("disconnected");
  }
  /**
   * Méthode appelée lorsqu'un formulaire contenant l'élément est réinitialisé.
   * Réinitialise l'état de l'élément.
   * @override
   */
  formResetCallback() {
    this.reset();
  }
  /**
   * Traite la valeur d'entrée en la divisant en balises, en ajoutant chaque balise, en
   * effaçant la valeur d'entrée et en mettant à jour la valeur du formulaire.
   * @emits {CustomEvent} process-input-event - Événement émis avant le traitement de la valeur d'entrée.
   * Il peut être annulé pour empêcher le traitement.
   */
  processInput() {
    !this.dispatchCustomEvent("process-input-event", { cancelable: !0 }).defaultPrevented && this.input && this.input.value && (this.input.value.split(this.separator).forEach((t) => this.addTag(t)), this.input.value = "", this.requestUpdate(), this.updateFormValue());
  }
  /**
   * Supprime un tag en fonction de son index.
   * @param {number} index - L'index du tag à supprimer.
   * @emits {CustomEvent} remove-tag - Événement émis lorsqu'un tag est supprimé.
   */
  removeTagByIndex(e) {
    if (this.dispatchCustomEvent("remove-tag"), e < 0 || e >= this.value.length) {
      console.error("Index not found");
      return;
    }
    this.value.splice(e, 1), this.requestUpdate("value"), this.updateFormValue();
  }
  /**
   * Rendu de l'élément.
   */
  render() {
    return x`
        <div class="es_tags-input" data-disabled="${this.disabled}">

            <div class="es_tags-input-tags-list">
                ${this.value.map((e, t) => x`
                        <button type="button" @click=${() => this.removeTagByIndex(t)} ?disabled="${this.disabled}">
                            
                            ${q(this.icons.closeSm)}

                            <span class="es_tags-input-tags-item">${e}</span>
                        </button>
                    `)}
                <slot @keyup="${this.onInputKeyUp}" @keydown="${this.onInputKeyDown}"></slot>

            </div>
        </div>`;
  }
  /**
   * Affiche un message de validation si l'élément est invalide.
   * @returns {boolean} - Renvoie true si l'élément est valide, sinon false.
   */
  reportValidity() {
    return this._internals.reportValidity();
  }
  /** Réinitialise la valeur selon la valeur initiale. */
  reset() {
    this.dispatchCustomEvent("reset", { cancelable: !0 }).defaultPrevented || (this.value = [...this._initialValue]);
  }
  /**
   * Met à jour la valeur du formulaire avec les tags ajoutés.
   */
  async updateFormValue(e = !0) {
    if (this.form) {
      const t = new FormData();
      this.value.forEach((r) => {
        this.name && t.append(this.name, r);
      }), this._internals.setFormValue(t), e && this.dispatchCustomEvent("change", { detail: this.value });
      const o = await this.getDefaultValidationMessages();
      if (this.matches(":disabled"))
        this._internals.setValidity({});
      else {
        let r = { valueMissing: !1, rangeUnderflow: !1, rangeOverflow: !1 }, a;
        if (this.hasAttribute("required") && !this.value.length && (r.valueMissing = !0, a = this.dataset.requiredMsg || (o == null ? void 0 : o.required()) || "required"), this.hasAttribute("min") && this.value.length) {
          const d = parseInt(this.getAttribute("min") || "0");
          this.value.length < d && (r.rangeUnderflow = !0, a = this.dataset.minMsg || (o == null ? void 0 : o.min(d.toString())) || `Minimum required of ${d} item(s).`);
        }
        if (this.hasAttribute("max") && this.value.length) {
          const d = parseInt(this.getAttribute("max") || "0");
          this.value.length > d && (r.rangeOverflow = !0, a = this.dataset.maxMsg || (o == null ? void 0 : o.max(d.toString())) || `Maximum required of ${d} item(s).`);
        }
        this._internals.setValidity(r, a);
      }
    }
  }
  /**
   * Retourne une promesse qui se résout en un objet contenant les messages de validation par
   * défaut pour la langue actuelle.
   */
  getDefaultValidationMessages() {
    var t;
    let e = ((t = document.querySelector("html")) == null ? void 0 : t.lang) || "en";
    return new Promise((o, r) => {
      Me(/* @__PURE__ */ Object.assign({ "../validation/i18n/bg.js": () => import("./chunks/validation/i18n/bg-17af7516.js"), "../validation/i18n/cs.js": () => import("./chunks/validation/i18n/cs-61f9ae0c.js"), "../validation/i18n/da.js": () => import("./chunks/validation/i18n/da-fb058e09.js"), "../validation/i18n/de.js": () => import("./chunks/validation/i18n/de-c0fe2aed.js"), "../validation/i18n/el.js": () => import("./chunks/validation/i18n/el-d443b04c.js"), "../validation/i18n/en.js": () => import("./chunks/validation/i18n/en-6f382f53.js"), "../validation/i18n/es.js": () => import("./chunks/validation/i18n/es-c587801a.js"), "../validation/i18n/et.js": () => import("./chunks/validation/i18n/et-974fff63.js"), "../validation/i18n/fi.js": () => import("./chunks/validation/i18n/fi-d3cfdc2b.js"), "../validation/i18n/fr.js": () => import("./chunks/validation/i18n/fr-7b708919.js"), "../validation/i18n/ga.js": () => import("./chunks/validation/i18n/ga-8b7c6629.js"), "../validation/i18n/hr.js": () => import("./chunks/validation/i18n/hr-0e8af37a.js"), "../validation/i18n/hu.js": () => import("./chunks/validation/i18n/hu-cfd83840.js"), "../validation/i18n/it.js": () => import("./chunks/validation/i18n/it-6c439c29.js"), "../validation/i18n/lt.js": () => import("./chunks/validation/i18n/lt-f068b9c1.js"), "../validation/i18n/lv.js": () => import("./chunks/validation/i18n/lv-e84d9f13.js"), "../validation/i18n/mt.js": () => import("./chunks/validation/i18n/mt-77daad66.js"), "../validation/i18n/nl.js": () => import("./chunks/validation/i18n/nl-fe6705a2.js"), "../validation/i18n/pl.js": () => import("./chunks/validation/i18n/pl-3095fddc.js"), "../validation/i18n/pt.js": () => import("./chunks/validation/i18n/pt-b1b671bd.js"), "../validation/i18n/ro.js": () => import("./chunks/validation/i18n/ro-599b8821.js"), "../validation/i18n/sk.js": () => import("./chunks/validation/i18n/sk-1fc05c28.js"), "../validation/i18n/sl.js": () => import("./chunks/validation/i18n/sl-8e1b0666.js"), "../validation/i18n/sv.js": () => import("./chunks/validation/i18n/sv-4786c921.js") }), `../validation/i18n/${e}.js`).then((a) => {
        o(a.default);
      }).catch((a) => {
        r(a);
      });
    });
  }
  /** Méthode utilisée pour émettre des événements personnalisés avec un type spécifique sur l'élément principal. */
  dispatchCustomEvent(e, t) {
    const o = new CustomEvent(`${e}.es.tags-input`, t);
    return this.dispatchEvent(o), o;
  }
  /**
   * Gère l'événement de perte de focus sur l'élément input.
   */
  onInputBlur(e) {
    const t = this.dispatchCustomEvent("blur", { cancelable: !0, detail: { relatedTarget: e.relatedTarget } });
    this.focused = !1, t.defaultPrevented || this.processInput();
  }
  /**
   * Gère l'événement de focus sur l'élément input.
   */
  onInputFocus() {
    this.dispatchCustomEvent("focus", { cancelable: !0 }), this.focused = !0;
  }
  /**
   * Fonction personnalisée permettant de valider un tag spécifié.
   * @param {string} tag - Le tag à valider.
   * @returns {boolean} - Renvoie true si le tag est valide, sinon false.
   */
  get validateTag() {
    return this._validateTag;
  }
  set validateTag(e) {
    this._validateTag = e;
  }
  /**
   * Gère l'événement d'appui sur une touche sur l'élément input.
   * @param {KeyboardEvent} e - L'événement d'appui sur une touche.
   */
  onInputKeyDown(e) {
    var t, o;
    !((t = this.input) != null && t.value) && e.key === "Backspace" && this.removeTagByIndex(this.value.length - 1), (o = this.input) != null && o.value && e.key === "Enter" && e.preventDefault();
  }
  /**
   * Gère l'événement de relâchement d'une touche sur l'élément input.
   * @param {KeyboardEvent} e - L'événement de relâchement de touche.
   */
  onInputKeyUp(e) {
    this.input && (e.key === this.separator || e.key === "Enter" || this.input.value[this.input.value.length - 1] === this.separator) && this.processInput();
  }
  /** Synchronise l'attribut disabled de l'élément principal avec celui du champ input. */
  syncInputDisabledStatus() {
    var e, t;
    this.disabled ? (e = this.input) == null || e.setAttribute("disabled", "") : (t = this.input) == null || t.removeAttribute("disabled");
  }
};
C.formAssociated = !0;
C.styles = D(et);
F([
  h({ reflect: !0, attribute: "data-focused" })
], C.prototype, "focused", 2);
F([
  h({ type: Number, reflect: !0 })
], C.prototype, "max", 2);
F([
  h({ type: Number, reflect: !0 })
], C.prototype, "min", 2);
F([
  h({ reflect: !0 })
], C.prototype, "name", 2);
F([
  h({ attribute: !0, reflect: !0 })
], C.prototype, "separator", 2);
F([
  h({ reflect: !0 })
], C.prototype, "tabindex", 2);
F([
  h({ type: Boolean, attribute: !0, reflect: !0 })
], C.prototype, "unique", 2);
F([
  h({ type: Boolean, reflect: !0 })
], C.prototype, "disabled", 1);
F([
  h({ type: Array, attribute: !0, reflect: !0 })
], C.prototype, "value", 1);
C = F([
  z("es-tags-input")
], C);
const ot = '<?xml version="1.0" encoding="UTF-8"?><svg id="uuid-958d25e3-b8da-46a3-9ab0-be969029f8ca" xmlns="http://www.w3.org/2000/svg" width="10" height="6.8" viewBox="0 0 10 6.8"><g id="uuid-48a67eb8-b9e1-4722-9726-eba170fa12d9"><polygon id="uuid-bee3efc4-5b21-4a90-81be-8367295f7b23" points="5 6.8 10 1.3 10 0 9.9 0 5 5.5 0 0 0 1.3 5 6.8" style="stroke-width:0px;"/></g></svg>', nt = '<?xml version="1.0" encoding="UTF-8"?><svg id="uuid-ebfb528e-2a7e-48b3-9854-dd654c85a3ad" xmlns="http://www.w3.org/2000/svg" width="10" height="6.8" viewBox="0 0 10 6.8"><g id="uuid-bf118079-117e-4f33-a7a5-242f6f098577"><polygon id="uuid-d0c8ff55-489f-4ec1-92da-161f7ff7a406" points="5 0 10 5.5 10 6.8 9.9 6.8 5 1.3 0 6.8 0 5.5 5 0" style="stroke-width:0px;"/></g></svg>', me = () => {
  const e = Date.now(), t = Math.random().toString(36).substring(2, 15);
  return `${e}-${t}`;
}, st = `@charset "UTF-8";:host{display:block}.es_tree-option:not(.last){border-bottom:1px dotted #d1d3d4}.es_tree-option .es_tree-btn-group{display:flex}.es_tree-option .es_tree-btn-group button{border:none;background-color:transparent;padding:.375rem .75rem}.es_tree-option .es_tree-btn-group button.no-events{pointer-events:none}.es_tree-option .es_tree-btn-group button:not([disabled]){cursor:pointer}.es_tree-option .es_tree-btn-group button:not([disabled]):hover{color:#3c77bd;background-color:#f8f9fa}.es_tree-option .es_tree-btn-group button:focus{outline:none;background-color:#f8f9fa;color:#3c77bd;outline:2px dotted #d1d3d4}.es_tree-option .es_tree-btn-group button.es_tree-select-option-label-btn{flex-grow:1;text-align:left}
`;
var rt = Object.defineProperty, at = Object.getOwnPropertyDescriptor, j = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? at(t, o) : t, d = e.length - 1, c; d >= 0; d--)
    (c = e[d]) && (a = (r ? c(t, o, a) : c(a)) || a);
  return r && a && rt(t, o, a), a;
};
let _ = class extends B {
  constructor() {
    super(), this["aria-selected"] = "false", this._disabled = !1, this.id = me(), this.label = "", this.role = "treeitem", this.selected = !1;
  }
  /** Element `es-tree-opt-group` le plus proche. */
  get group() {
    return this.parentElement;
  }
  /** Retourne l'ensemble des éléments `EsTreeOptGroupElement` parents. */
  get allParentsGroups() {
    const e = (t, o = []) => (o.push(t), t.group && e(t.group, o), o);
    return this.group ? e(this.group) : [];
  }
  get disabled() {
    const e = !!this.allParentsGroups.find((t) => t.disabled);
    return this._disabled || e;
  }
  set disabled(e) {
    const t = this.disabled;
    this._disabled = e, this.requestUpdate("disabled", t), this.dispatchEvent(new Event("change", { bubbles: !0, composed: !0 }));
  }
  /** Référence vers l'élément du content `es-tree-content`. */
  get content() {
    return this.closest("es-tree-content");
  }
  get currentIdNamespace() {
    return `esTreeOption-${this.id}`;
  }
  /** Référence à l'élément parent `EsTreeElement`. */
  get tree() {
    var e;
    return (e = this.content) == null ? void 0 : e.tree;
  }
  /** Retourne la valeur de l'option. */
  get value() {
    return this._value;
  }
  set value(e) {
    this._value = e;
  }
  get _hasSlot() {
    var e, t;
    return (t = (e = this.shadowRoot) == null ? void 0 : e.querySelector("slot")) == null ? void 0 : t.assignedElements({ flatten: !0 }).length;
  }
  /**
   * Retourne `true` si l'élément parent existe et que le premier enfant de l'élément parent est cet élément.
   * @returns Une valeur booléenne qui est vraie si l'élément est le premier enfant de son parent.
   */
  get isFirstElement() {
    var e;
    return ((e = this.parentElement) == null ? void 0 : e.firstElementChild) === this;
  }
  /**
   * Retourne `true` si l'élément parent existe et que le dernier enfant de l'élément parent est le même que l'élément actuel.
   * @returns Une valeur booléenne.
   */
  get isLastElement() {
    var e;
    return ((e = this.parentElement) == null ? void 0 : e.lastElementChild) === this;
  }
  attributeChangedCallback(e, t, o) {
    super.attributeChangedCallback(e, t, o), e === "selected" && (this["aria-selected"] = o !== null ? "true" : "false");
  }
  /**
   * Ajoute des écouteurs d'événements.
   */
  connectedCallback() {
    var e, t, o;
    super.connectedCallback(), (e = this.content) == null || e.addEventListener("filter.es.tree", this.onContentFilterHandle.bind(this)), (t = this.content) == null || t.addEventListener("toggle.es.tree", this.onContentChangeHandle.bind(this)), (o = this.content) == null || o.addEventListener("change", this.onContentChangeHandle.bind(this));
  }
  /**
   * Supprime les écouteurs d'événements.
   */
  disconnectedCallback() {
    var e, t, o;
    (e = this.content) == null || e.removeEventListener("filter.es.tree", this.onContentFilterHandle.bind(this)), (t = this.content) == null || t.removeEventListener("toggle.es.tree", this.onContentChangeHandle.bind(this)), (o = this.content) == null || o.removeEventListener("change", this.onContentChangeHandle.bind(this)), super.disconnectedCallback();
  }
  /**
   * Basculer la sélection.
   */
  toggle() {
    var e, t, o;
    !this.disabled && !((e = this.group) != null && e.disabled) && ((t = this.tree) != null && t.multiple || (o = this.tree) == null || o.clear(), this.selected = !this.selected, this.dispatchEvent(new Event("change", { bubbles: !0, composed: !0 })));
  }
  /**
   * Méthode de rendu du modèle.
   */
  render() {
    var o, r, a, d, c;
    let e = ee({
      "es_tree-option": !0,
      disabled: this.disabled || !1,
      selected: this.selected,
      last: this.isLastElement,
      first: this.isFirstElement
    }), t = ee({
      "no-events": ((o = this.tree) == null ? void 0 : o.allowLabelToSelect) === "none"
    });
    return x`

            <div class="${e}">
            
                <div class="es_tree-btn-group">
            
                    <button type="button"
                    @click="${this.onSelectButtonClick}" 
                    ?disabled="${this.disabled || ((r = this.group) == null ? void 0 : r.disabled)}"
                    aria-selected="${this.selected}"
                    aria-labelledby="${this.currentIdNamespace}Label"
                    id="${this.currentIdNamespace}Select">
                        <es-custom-checkbox type="${(a = this.tree) != null && a.multiple ? "checkbox" : "radio"}" checked="${this.selected ? "checked" : "empty"}" ?disabled=${this.disabled || ((d = this.group) == null ? void 0 : d.disabled)}></es-custom-checkbox>
                    </button>

                    <button type="button" class="es_tree-select-option-label-btn ${t}"
                    @click="${this.onLabelButtonClickHandle}"
                    ?disabled="${this.disabled || ((c = this.group) == null ? void 0 : c.disabled)}"
                    tabindex="-1"
                    id="${this.currentIdNamespace}Label">
                        <span class="es_tree-option-label">
                            ${this._hasSlot ? null : this.label}
                            <slot></slot>
                        </span>
                    </button>
                </div>

            </div>
        `;
  }
  /**
   * Gestion de l’événement `change` émit par le composant parent.
   */
  onContentChangeHandle() {
    this.requestUpdate();
  }
  /**
   * Gestion de l’événement `filter.es.tree`
   */
  onContentFilterHandle(e) {
    const t = e.detail;
    t ? this.label.toLowerCase().indexOf(t.toLowerCase()) > -1 ? this.hidden = !1 : this.hidden = !0 : this.hidden = !1;
  }
  /** 
   * Gestion de l’événement lors du clic sur le label.
   */
  onLabelButtonClickHandle(e) {
    var t, o;
    e.stopPropagation(), (((t = this.tree) == null ? void 0 : t.allowLabelToSelect) == "all" || ((o = this.tree) == null ? void 0 : o.allowLabelToSelect) === "withoutChildrenOnly") && this.toggle();
  }
  /**
   * Gestion de l’événement lors du clic sur le bouton de sélection.
   * @param {Event} event - L'événement qui a déclenché la fonction.
   */
  onSelectButtonClick(e) {
    e.stopPropagation(), this.toggle();
  }
};
_.styles = Se`${D(st)}`;
j([
  h({ reflect: !0 })
], _.prototype, "aria-selected", 2);
j([
  h({ type: Boolean, reflect: !0 })
], _.prototype, "_disabled", 2);
j([
  h()
], _.prototype, "id", 2);
j([
  h()
], _.prototype, "label", 2);
j([
  h()
], _.prototype, "role", 2);
j([
  h({ type: Boolean, attribute: !0, reflect: !0 })
], _.prototype, "selected", 2);
j([
  h()
], _.prototype, "value", 1);
j([
  V()
], _.prototype, "_hasSlot", 1);
_ = j([
  z("es-tree-option")
], _);
const lt = `@charset "UTF-8";*,*:before,*:after{box-sizing:border-box}html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-ms-overflow-style:scrollbar;-webkit-tap-highlight-color:rgba(0,0,0,0)}@-ms-viewport{width:device-width}article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}body{margin:0;font-family:Helvetica,Arial,sans-serif,Segoe UI,Roboto,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol;font-size:.875rem;font-weight:400;line-height:1.5;color:#1e1e1f;text-align:left;background-color:#fff}[tabindex="-1"]:focus{outline:0!important}hr{box-sizing:content-box;height:0;overflow:visible}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5rem}p{margin-top:0;margin-bottom:1rem}abbr[title],abbr[data-original-title]{text-decoration:underline;text-decoration:underline dotted;cursor:help;border-bottom:0}address{margin-bottom:1rem;font-style:normal;line-height:inherit}ol,ul,dl{margin-top:0;margin-bottom:1rem}ol ol,ul ul,ol ul,ul ol{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 1rem}dfn{font-style:italic}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:#3c77bd;text-decoration:none;background-color:transparent;-webkit-text-decoration-skip:objects}a:hover{color:#2a5283;text-decoration:none}.bg-light a:not(.btn){color:#3a72b5}.bg-light a:not(.btn):hover{color:#274e7b}.bg-light-gradient a:not(.btn){color:#3568a6}.bg-light-gradient a:not(.btn):hover{color:#22446c}a:not([href]):not([tabindex]){color:inherit;text-decoration:none}a:not([href]):not([tabindex]):hover,a:not([href]):not([tabindex]):focus{color:inherit;text-decoration:none}a:not([href]):not([tabindex]):focus{outline:0}pre,code,kbd,samp{font-family:monospace,monospace;font-size:1em}pre{margin-top:0;margin-bottom:1rem;overflow:auto;-ms-overflow-style:scrollbar}figure{margin:0 0 1rem}img{vertical-align:middle;border-style:none}svg:not(:root){overflow:hidden}table{border-collapse:collapse}caption{padding-top:.75rem;padding-bottom:.75rem;color:#6c757d;text-align:left;caption-side:bottom}th{text-align:inherit}label{display:inline-block;margin-bottom:.5rem}button{border-radius:0}button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}input,button,select,optgroup,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}button,html [type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{padding:0;border-style:none}input[type=radio],input[type=checkbox]{box-sizing:border-box;padding:0}input[type=date],input[type=time],input[type=datetime-local],input[type=month]{-webkit-appearance:listbox}textarea{overflow:auto;resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output{display:inline-block}summary{display:list-item;cursor:pointer}template{display:none}[hidden]{display:none!important}button.es_tree-control{display:flex;justify-content:space-between;width:100%;padding:.375rem .75rem;font-size:.875rem;line-height:1.5;color:#505154;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;text-align:left;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media screen and (prefers-reduced-motion: reduce){button.es_tree-control{transition:none}}button.es_tree-control::-ms-expand{background-color:transparent;border:0}button.es_tree-control:focus{color:#505154;background-color:#fff;border-color:#3c77bd;outline:0;box-shadow:"none"}button.es_tree-control::placeholder{color:#6c757d;opacity:1}button.es_tree-control:disabled,button.es_tree-control[readonly]{background-color:#f3f4f4;opacity:1}.es_tree-control.form-control{text-align:left;cursor:pointer;display:flex;justify-content:space-between}.es_tree-control.form-control:hover{background-color:#f8f9fa}.es_tree-control.form-control[aria-expanded=true]{border-color:#3c77bd;z-index:1061;position:relative}.es_tree-control.form-control[aria-expanded=true][data-orientation=up]{border-top-color:#fff;border-top-left-radius:0;border-top-right-radius:0}.es_tree-control.form-control[aria-expanded=true][data-orientation=down]{border-bottom-color:#fff;border-bottom-right-radius:0;border-bottom-left-radius:0}.es_tree-control.form-control .es_tree-control-icon{margin-left:1rem}.es_tree-control.form-control[aria-expanded=true] .es_tree-control-icon svg{fill:#3c77bd}
`;
var dt = Object.defineProperty, ct = Object.getOwnPropertyDescriptor, y = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? ct(t, o) : t, d = e.length - 1, c; d >= 0; d--)
    (c = e[d]) && (a = (r ? c(t, o, a) : c(a)) || a);
  return r && a && dt(t, o, a), a;
};
let g = class extends B {
  constructor() {
    super(), this.icons = {
      arrowDown: ot,
      arrowUp: nt
    }, this._expanded = !1, this._orientation = "down", this._originX = "start", this.buttonRef = ae(), this.allowLabelToSelect = "withoutChildrenOnly", this.disabled = !1, this.disallowLabelToExpand = !1, this.id = me(), this.multiple = !1, this.placeholder = "Select a value", this.showRefiner = !1, this.tabindex = "0", this.valueMode = "list", this.addEventListener("change", () => {
      this.updateFormValue(), this.requestUpdate();
    }), this.addEventListener("toggle.es.tree", () => {
      this.requestUpdate();
    }), this.addEventListener("orientationChange.es.tree", (e) => {
      this._orientation = e.detail;
    }), this.addEventListener("originXChange.es.tree", (e) => {
      this._originX = e.detail;
    }), this.addEventListener("filter.es.tree", () => {
    }), this.addEventListener("close.es.tree", () => {
      this._expanded = !1;
    }), this.addEventListener("open.es.tree", () => {
      this._expanded = !0;
    }), this.addEventListener("focus", () => {
      var e;
      return (e = this.buttonRef.value) == null ? void 0 : e.focus();
    }), this.internals = this.attachInternals();
  }
  /**
   * Retourne les options actuellement affichées.
   */
  get filteredOptions() {
    return this.options.filter((e) => !e.hidden);
  }
  connectedCallback() {
    super.connectedCallback(), this.relatedContent && (this.relatedContent.tree = this), this.dispatchEvent(new CustomEvent("connected.es.tree", { composed: !0 }));
  }
  /**
   * Renvoie l'étiquette des éléments sélectionnés, séparés par des virgules.
   * @returns {String} Chaîne de caractères contenant l'étiquette des éléments sélectionnés.
   */
  get groupedLabel() {
    return this.groupedSelectedElements.map((e) => e.label).join(", ");
  }
  /**
   * Cette fonction renvoie un tableau d'options et d'optgroups sélectionnés.
   * @returns Un tableau contenant toutes les options sélectionnées et les optgroups sélectionnés du composant. 
   */
  get selectedElements() {
    return [...this.selectedOptions, ...this.selectedOptGroups];
  }
  /**
   * Renvoie un tableau contenant les éléments sélectionnés triés par groupe, puis non triés.
   * Les éléments sont triés dans l'ordre hiérarchique des groupes sélectionnés.
   * Les groupes avec des options partiellement sélectionnées ne seront pas inclus.
   * Les options qui ne sont pas dans un groupe seront ajoutées à la fin du tableau dans l'ordre où elles ont été sélectionnées.
   * @returns {Array} Tableau trié des éléments sélectionnés.
   */
  get groupedSelectedElements() {
    if (!this.multiple) {
      const a = this.selectedOptGroups.filter((c) => c.value), d = [...this.selectedOptions, ...a].find((c) => c.selected && !c.disabled);
      return d ? [d] : [];
    }
    const e = [], t = (a) => {
      const d = a.allParentsGroups.filter((c) => c.value && c.childrenState === "all" && !c.uncheckable && !c.disabled);
      return d && d.length ? d[d.length - 1] : null;
    };
    this.selectedOptions.forEach((a) => {
      if (a.group) {
        const d = t(a);
        d && e.push(d);
      }
    });
    const o = Array.from(new Set(e)), r = this.selectedOptions.filter((a) => !a.group || !t(a));
    return [...o, ...r];
  }
  /** 
   * Retourne un tableau de tous les groupes de l'arborescence.
   */
  get groups() {
    return this.relatedContent ? Array.from(this.relatedContent.querySelectorAll("es-tree-opt-group")) : [];
  }
  /**
   * Retourne un tableau de toutes les options de l'arborescence.
   */
  get options() {
    return this.relatedContent ? Array.from(this.relatedContent.querySelectorAll("es-tree-option")) : [];
  }
  /**
   * Retourne l'élément qui correspond à la propriété de contenu.
   */
  get relatedContent() {
    return this.content ? document.querySelector(this.content) : null;
  }
  /**
   * Retourne un tableau de toutes les options sélectionnées et non désactivées
   * @returns Un tableau d'objets `EsTreeOptionElement` qui sont sélectionnés et non désactivés.
   */
  get selectedOptions() {
    return this.options.filter((e) => e.selected && !e.disabled);
  }
  /**
       * Retourne un tableau d'objets `EsTreeOptGroupElement` sélectionnés et non désactivés
       * à partir d'un tableau de groupes.
       * @returns Un tableau d'objets `EsTreeOptGroupElement` qui sont sélectionnés et non désactivés.
  
       */
  get selectedOptGroups() {
    return this.groups.filter((e) => e.selected && !e.disabled);
  }
  get value() {
    return this.valueMode === "grouped" ? this.valueGrouped : this.valueList;
  }
  /** Retourne les valeurs séparées par une virgule. */
  get valueAsString() {
    return this.value.join(", ");
  }
  /**
   * Applique une valeur selon les options disponibles. Les valeurs doivent être séparées par ", " lorsqu'une sélection multiple est souhaitée.
   * @param {string} value - La valeur de l'entrée.
   */
  set value(e) {
    this.clear(), e.forEach((t) => {
      [...this.options, ...this.groups].forEach((o) => {
        var r;
        o instanceof _ ? o.value === t && (o.selected = !0) : o.value === t && ((r = o.childrenOptions) == null || r.forEach((a) => {
          a.selected = !0;
        }));
      });
    }), this.updateFormValue(), this.requestUpdate();
  }
  /** Méthode propre au formulaire API `ElementInternals` */
  get form() {
    return this.internals.form;
  }
  /** Méthode propre au formulaire API `ElementInternals` */
  get type() {
    return `tree-${this.multiple ? "multiple" : "one"}`;
  }
  /** Méthode propre au formulaire API `ElementInternals` */
  get validationMessage() {
    return this.internals.validationMessage;
  }
  /** Méthode propre au formulaire API `ElementInternals` */
  get validity() {
    return this.internals.validity;
  }
  /** Méthode propre au formulaire API `ElementInternals` */
  get willValidate() {
    return this.internals.willValidate;
  }
  get valueGrouped() {
    return this.groupedSelectedElements.map((e) => e.value ? e.value : e instanceof m ? (e.childrenSelectableOptions || []).filter((t) => t.value && t.selected).map((t) => t.value || "") : "").flat().filter((e) => e);
  }
  get valueList() {
    const e = this.selectedElements.filter((t) => t.value);
    return this.multiple ? e.map((t) => t.value) : e.filter((t) => t.selected).map((t) => t.value || "");
  }
  /**
   * Parcourt toutes les options et définit leur propriété sélectionnée sur false
   */
  clear() {
    this.groups.forEach((e) => e.selected = !1), this.options.forEach((e) => e.selected = !1), this.requestUpdate(), this.updateFormValue();
  }
  /**
   * Fonction de mise à jour de la valeur du formulaire.
   */
  async updateFormValue() {
    if (!this.closest("form"))
      return;
    if (!this.multiple)
      this.internals.setFormValue(this.value.join(""));
    else if (this.name) {
      let t = new FormData();
      this.value.forEach((o) => {
        this.name && t.append(this.name, o);
      }), this.internals.setFormValue(t);
    } else
      console.warn("Please provide a name attribute for es-tree", this);
    const e = await this.getDefaultValidationMessages();
    if (this.matches(":disabled"))
      this.internals.setValidity({});
    else {
      let t = { valueMissing: !1, rangeUnderflow: !1, rangeOverflow: !1 }, o;
      if (this.hasAttribute("required") && !this.value.length && (t.valueMissing = !0, o = this.dataset.requiredMsg || (e == null ? void 0 : e.required()) || "required"), this.multiple && this.hasAttribute("min")) {
        const r = parseInt(this.getAttribute("min") || "0");
        this.selectedOptions.length < r && (t.rangeUnderflow = !0, o = this.dataset.minMsg || (e == null ? void 0 : e.min(r.toString())) || `Minimum required of ${r} item(s).`);
      }
      if (this.multiple && this.hasAttribute("max")) {
        const r = parseInt(this.getAttribute("max") || "0");
        this.selectedOptions.length > r && (t.rangeOverflow = !0, o = this.dataset.maxMsg || (e == null ? void 0 : e.max(r.toString())) || `Maximum required of ${r} item(s).`);
      }
      this.internals.setValidity(t, o);
    }
  }
  /** Méthode propre au formulaire API `ElementInternals` */
  checkValidity() {
    return this.internals.checkValidity();
  }
  /** Méthode du cycle de vie du composant. */
  firstUpdated(e) {
    this.updateFormValue(), this.dispatchEvent(new CustomEvent("firstupdated.es.tree", { composed: !0 }));
  }
  /** Méthode propre au formulaire API `ElementInternals` */
  formDisabledCallback(e) {
    this.disabled = e;
  }
  /**
   * Fonction appelée lorsque l'utilisateur clique sur le bouton de
   * réinitialisation du formulaire
   */
  formResetCallback() {
    this.clear();
  }
  /**
   * Retourne une promesse qui se résout en un objet contenant les messages de validation par
   * défaut pour la langue actuelle.
   */
  getDefaultValidationMessages() {
    var t;
    let e = ((t = document.querySelector("html")) == null ? void 0 : t.lang) || "en";
    return new Promise((o, r) => {
      Me(/* @__PURE__ */ Object.assign({ "../validation/i18n/bg.js": () => import("./chunks/validation/i18n/bg-17af7516.js"), "../validation/i18n/cs.js": () => import("./chunks/validation/i18n/cs-61f9ae0c.js"), "../validation/i18n/da.js": () => import("./chunks/validation/i18n/da-fb058e09.js"), "../validation/i18n/de.js": () => import("./chunks/validation/i18n/de-c0fe2aed.js"), "../validation/i18n/el.js": () => import("./chunks/validation/i18n/el-d443b04c.js"), "../validation/i18n/en.js": () => import("./chunks/validation/i18n/en-6f382f53.js"), "../validation/i18n/es.js": () => import("./chunks/validation/i18n/es-c587801a.js"), "../validation/i18n/et.js": () => import("./chunks/validation/i18n/et-974fff63.js"), "../validation/i18n/fi.js": () => import("./chunks/validation/i18n/fi-d3cfdc2b.js"), "../validation/i18n/fr.js": () => import("./chunks/validation/i18n/fr-7b708919.js"), "../validation/i18n/ga.js": () => import("./chunks/validation/i18n/ga-8b7c6629.js"), "../validation/i18n/hr.js": () => import("./chunks/validation/i18n/hr-0e8af37a.js"), "../validation/i18n/hu.js": () => import("./chunks/validation/i18n/hu-cfd83840.js"), "../validation/i18n/it.js": () => import("./chunks/validation/i18n/it-6c439c29.js"), "../validation/i18n/lt.js": () => import("./chunks/validation/i18n/lt-f068b9c1.js"), "../validation/i18n/lv.js": () => import("./chunks/validation/i18n/lv-e84d9f13.js"), "../validation/i18n/mt.js": () => import("./chunks/validation/i18n/mt-77daad66.js"), "../validation/i18n/nl.js": () => import("./chunks/validation/i18n/nl-fe6705a2.js"), "../validation/i18n/pl.js": () => import("./chunks/validation/i18n/pl-3095fddc.js"), "../validation/i18n/pt.js": () => import("./chunks/validation/i18n/pt-b1b671bd.js"), "../validation/i18n/ro.js": () => import("./chunks/validation/i18n/ro-599b8821.js"), "../validation/i18n/sk.js": () => import("./chunks/validation/i18n/sk-1fc05c28.js"), "../validation/i18n/sl.js": () => import("./chunks/validation/i18n/sl-8e1b0666.js"), "../validation/i18n/sv.js": () => import("./chunks/validation/i18n/sv-4786c921.js") }), `../validation/i18n/${e}.js`).then((a) => {
        o(a.default);
      }).catch((a) => {
        r(a);
      });
    });
  }
  /**
   * Méthode appelée lors du clic sur le bouton principal.
   */
  onMainButtonClick() {
    this.relatedContent && (this.relatedContent.tree = this, this.relatedContent.hidden = !this.relatedContent.hidden, this.relatedContent.dispatchEvent(new CustomEvent("toggle.es.tree", { bubbles: !0, composed: !0 })));
  }
  /** Méthode de rendu du modèle. */
  render() {
    let e = ee({
      "es_tree-control": !0,
      "form-control": !0
    });
    return x`

            <button part="button" type="button"
            class="${e}" 
            ?disabled="${this.disabled}"
            aria-expanded="${this._expanded}"
            data-orientation="${Y(this._orientation)}"
            data-originX="${Y(this._originX)}"
            @click="${this.onMainButtonClick}" 
            ${le(this.buttonRef)}>
                <span>${this.groupedLabel || this.placeholder}</span>
                <span class="es_tree-control-icon">${q(this._expanded ? this.icons.arrowUp : this.icons.arrowDown)}</span>
            </button>
            
    `;
  }
  /** Méthode propre au formulaire API `ElementInternals` */
  reportValidity() {
    return this.internals.reportValidity();
  }
};
g.formAssociated = !0;
g.styles = D(lt);
y([
  V()
], g.prototype, "_expanded", 2);
y([
  V()
], g.prototype, "_orientation", 2);
y([
  V()
], g.prototype, "_originX", 2);
y([
  h({ reflect: !0 })
], g.prototype, "allowLabelToSelect", 2);
y([
  h({ reflect: !0 })
], g.prototype, "content", 2);
y([
  h({ type: Boolean, reflect: !0 })
], g.prototype, "disabled", 2);
y([
  h({ type: Boolean, reflect: !0 })
], g.prototype, "disallowLabelToExpand", 2);
y([
  h({ reflect: !0 })
], g.prototype, "id", 2);
y([
  h({ type: Boolean, reflect: !0 })
], g.prototype, "multiple", 2);
y([
  h({ reflect: !0 })
], g.prototype, "name", 2);
y([
  h()
], g.prototype, "placeholder", 2);
y([
  h({ type: Boolean, reflect: !0 })
], g.prototype, "showRefiner", 2);
y([
  h({ reflect: !0 })
], g.prototype, "tabindex", 2);
y([
  h({ reflect: !0 })
], g.prototype, "valueMode", 2);
y([
  h({ attribute: !1 })
], g.prototype, "value", 1);
g = y([
  z("es-tree")
], g);
function re(e, t, o, r = 20, a = 0) {
  let d = [];
  if (a >= r)
    return d;
  const c = (v) => {
    const k = v.assignedNodes().filter((R) => R.nodeType === 1);
    return k.length > 0 ? re(k[0].parentElement, t, o, r, a + 1) : [];
  }, w = Array.from(e.children || []);
  for (const v of w)
    t(v) || (o(v) && d.push(v), v.shadowRoot != null ? d.push(...re(v.shadowRoot, t, o, r, a + 1)) : v.tagName === "SLOT" ? d.push(...c(v)) : d.push(...re(v, t, o, r, a + 1)));
  return d;
}
function Te(e) {
  return e.hasAttribute("hidden") || e.hasAttribute("aria-hidden") && e.getAttribute("aria-hidden") !== "false" || e.style.display === "none" || e.style.opacity === "0" || e.style.visibility === "hidden" || e.style.visibility === "collapse";
}
function ut(e) {
  return e.hasAttribute("disabled") || e.hasAttribute("aria-disabled") && e.getAttribute("aria-disabled") !== "false";
}
function ht(e) {
  return e.getAttribute("tabindex") === "-1" || Te(e) || ut(e) ? !1 : (
    // At this point we know that the element can have focus (eg. won't be -1) if the tabindex attribute exists
    e.hasAttribute("tabindex") || (e instanceof HTMLAnchorElement || e instanceof HTMLAreaElement) && e.hasAttribute("href") || e instanceof HTMLButtonElement || e instanceof HTMLInputElement || e instanceof HTMLTextAreaElement || e instanceof HTMLSelectElement || e instanceof HTMLIFrameElement
  );
}
const fe = /* @__PURE__ */ new Map();
function pt(e, t, o) {
  const r = fe.get(o);
  r != null && window.clearTimeout(r), fe.set(o, window.setTimeout(() => {
    e(), fe.delete(o);
  }, t));
}
const Fe = document.createElement("template");
Fe.innerHTML = `
	<div id="start"></div>
	<div id="backup"></div>
	<slot></slot>
	<div id="end"></div>
`;
class bt extends HTMLElement {
  /**
   * Attaches the shadow root.
   */
  constructor() {
    super(), this.debounceId = Math.random().toString(), this._focused = !1;
    const t = this.attachShadow({ mode: "open" });
    t.appendChild(Fe.content.cloneNode(!0)), this.$backup = t.querySelector("#backup"), this.$start = t.querySelector("#start"), this.$end = t.querySelector("#end"), this.focusLastElement = this.focusLastElement.bind(this), this.focusFirstElement = this.focusFirstElement.bind(this), this.onFocusIn = this.onFocusIn.bind(this), this.onFocusOut = this.onFocusOut.bind(this);
  }
  // Whenever one of these attributes changes we need to render the template again.
  static get observedAttributes() {
    return [
      "inactive"
    ];
  }
  /**
   * Determines whether the focus trap is active or not.
   * @attr
   */
  get inactive() {
    return this.hasAttribute("inactive");
  }
  set inactive(t) {
    t ? this.setAttribute("inactive", "") : this.removeAttribute("inactive");
  }
  /**
   * Returns whether the element currently has focus.
   */
  get focused() {
    return this._focused;
  }
  /**
   * Hooks up the element.
   */
  connectedCallback() {
    this.$start.addEventListener("focus", this.focusLastElement), this.$end.addEventListener("focus", this.focusFirstElement), this.addEventListener("focusin", this.onFocusIn), this.addEventListener("focusout", this.onFocusOut), this.render();
  }
  /**
   * Tears down the element.
   */
  disconnectedCallback() {
    this.$start.removeEventListener("focus", this.focusLastElement), this.$end.removeEventListener("focus", this.focusFirstElement), this.removeEventListener("focusin", this.onFocusIn), this.removeEventListener("focusout", this.onFocusOut);
  }
  /**
   * When the attributes changes we need to re-render the template.
   */
  attributeChangedCallback() {
    this.render();
  }
  /**
   * Focuses the first focusable element in the focus trap.
   */
  focusFirstElement() {
    this.trapFocus();
  }
  /**
   * Focuses the last focusable element in the focus trap.
   */
  focusLastElement() {
    this.trapFocus(!0);
  }
  /**
   * Returns a list of the focusable children found within the element.
   */
  getFocusableElements() {
    return re(this, Te, ht);
  }
  /**
   * Focuses on either the last or first focusable element.
   * @param {boolean} trapToEnd
   */
  trapFocus(t) {
    if (this.inactive)
      return;
    let o = this.getFocusableElements();
    o.length > 0 ? (t ? o[o.length - 1].focus() : o[0].focus(), this.$backup.setAttribute("tabindex", "-1")) : (this.$backup.setAttribute("tabindex", "0"), this.$backup.focus());
  }
  /**
   * When the element gains focus this function is called.
   */
  onFocusIn() {
    this.updateFocused(!0);
  }
  /**
   * When the element looses its focus this function is called.
   */
  onFocusOut() {
    this.updateFocused(!1);
  }
  /**
   * Updates the focused property and updates the view.
   * The update is debounced because the focusin and focusout out
   * might fire multiple times in a row. We only want to render
   * the element once, therefore waiting until the focus is "stable".
   * @param value
   */
  updateFocused(t) {
    pt(() => {
      this.focused !== t && (this._focused = t, this.render());
    }, 0, this.debounceId);
  }
  /**
   * Updates the template.
   */
  render() {
    this.$start.setAttribute("tabindex", !this.focused || this.inactive ? "-1" : "0"), this.$end.setAttribute("tabindex", !this.focused || this.inactive ? "-1" : "0"), this.focused ? this.setAttribute("focused", "") : this.removeAttribute("focused");
  }
}
window.customElements.define("focus-trap", bt);
const ft = '<?xml version="1.0" encoding="UTF-8"?><svg id="uuid-b03aed12-553f-4bd7-91fc-ee643b74eb01" xmlns="http://www.w3.org/2000/svg" width="6.8" height="10" viewBox="0 0 6.8 10"><g id="uuid-e3b20b51-be58-49bf-b4e8-b99ef4d3c44d"><polygon id="uuid-09dfe5bc-5f93-4861-9f55-43c247179f63" points="6.8 5 1.3 0 0 0 0 .1 5.5 5 0 10 1.3 10 6.8 5" style="stroke-width:0px;"/></g></svg>', mt = '<?xml version="1.0" encoding="UTF-8"?><svg id="uuid-2ef5b079-42de-4579-8e6a-ca337cf1ccf1" xmlns="http://www.w3.org/2000/svg" width="9" height="1" viewBox="0 0 9 1"><g id="uuid-54104790-9955-47e4-85ad-a83d1fe147d5"><rect id="uuid-868a2a54-a177-4930-8e7d-976d517b776c" width="9" height="1" style="stroke-width:0px;"/></g></svg>', gt = '<?xml version="1.0" encoding="UTF-8"?><svg id="uuid-d1faa528-2eea-4194-ace9-051cc4130de8" xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9"><g id="uuid-50b79d77-16cd-43a5-aaea-6a1e138339be"><polygon id="uuid-1e5ff7b1-098d-4e34-8f46-dadda3a1ba94" points="5 9 4 9 4 5 0 5 0 4 4 4 4 0 5 0 5 4 9 4 9 5 5 5 5 9" style="stroke-width:0px;"/></g></svg>', vt = `@charset "UTF-8";:host{display:block}.es_tree-opt-group:not(.last){border-bottom:1px dotted #d1d3d4}.es_tree-opt-group .es_tree-opt-group-list{display:none;margin-left:1rem;padding-left:1rem;border-left:1px solid #d1d3d4}.es_tree-opt-group .es_tree-opt-group-list.active{display:block}.es_tree-opt-group .es_tree-expand-icon{border:1px solid #d1d3d4;display:inline-flex;width:16px;height:16px;align-items:center;justify-content:center;border-radius:50%;vertical-align:middle}.es_tree-opt-group .es_tree-opt-group-button{display:flex}.es_tree-opt-group .es_tree-opt-group-button button{border:none;background-color:transparent;padding:.375rem .75rem}.es_tree-opt-group .es_tree-opt-group-button button.no-events{pointer-events:none}.es_tree-opt-group .es_tree-opt-group-button button:not([disabled]){cursor:pointer}.es_tree-opt-group .es_tree-opt-group-button button:not([disabled]):hover{color:#3c77bd;background-color:#f8f9fa}.es_tree-opt-group .es_tree-opt-group-button button:focus{outline:none;background-color:#f8f9fa;color:#3c77bd;outline:2px dotted #d1d3d4}.es_tree-opt-group .es_tree-opt-group-button button.es_tree-opt-group-select-btn .es_tree-opt-group-select-btn-arrow{min-width:13px;display:inline-block}.es_tree-opt-group .es_tree-opt-group-button button.es_tree-opt-group-select-btn .es_tree-opt-group-select-btn-arrow.active{fill:#3c77bd}.es_tree-opt-group .es_tree-opt-group-button button.es_tree-opt-group-label-btn{flex-grow:1;text-align:left;font-weight:700}.es_tree-opt-group .es_tree-opt-group-button button.es_tree-expand-btn{display:flex}.es_tree-opt-group .es_tree-opt-group-button button.es_tree-expand-btn .es_tree-expand-icon{border:1px solid #d1d3d4;border-radius:50%;width:17px;height:17px;display:flex;align-items:center;justify-content:center}
`;
var yt = Object.defineProperty, wt = Object.getOwnPropertyDescriptor, L = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? wt(t, o) : t, d = e.length - 1, c; d >= 0; d--)
    (c = e[d]) && (a = (r ? c(t, o, a) : c(a)) || a);
  return r && a && yt(t, o, a), a;
};
let m = class extends B {
  constructor() {
    super(...arguments), this.icons = {
      arrowRight: ft,
      less: mt,
      more: gt,
      check: Le
    }, this["aria-selected"] = this.selected, this._disabled = !1, this.expanded = !1, this.id = me(), this.label = "", this.role = "treeitem", this.uncheckable = !1, this._selected = !1;
  }
  /** Element `es-tree-opt-group` le plus proche. */
  get group() {
    return this.parentElement instanceof m ? this.parentElement : null;
  }
  /** Retourne l'ensemble des éléments `EsTreeOptGroupElement` parents. */
  get allParentsGroups() {
    const e = (t, o = []) => (o.push(t), t.group && e(t.group, o), o);
    return this.group ? e(this.group) : [];
  }
  get disabled() {
    const e = !!this.allParentsGroups.find((t) => t.disabled);
    return this._disabled || e;
  }
  set disabled(e) {
    const t = this.disabled;
    this._disabled = e, this.requestUpdate("disabled", t), this.dispatchEvent(new Event("change", { bubbles: !0, composed: !0 }));
  }
  /**
   * Retourne un tableau de tous les éléments enfants de l'élément actuel qui sont de type
   * es-tree-option.
   * @returns Un tableau de tous les éléments `es-tree-option` dans le shadow dom.
   */
  get childrenOptions() {
    return Array.from(this.querySelectorAll("es-tree-option"));
  }
  /**
   * Retourne un tableau d'objets EsTreeOptionElement qui ne sont pas désactivés.
   * @returns Un tableau d'objets EsTreeOptionElement qui ne sont pas désactivés et qui ne se
   * trouvent pas dans un groupe désactivé.
   */
  get childrenSelectableOptions() {
    var e;
    return (e = this.childrenOptions) == null ? void 0 : e.filter((t) => {
      var o;
      return !((o = t.group) != null && o.disabled) && !t.disabled;
    });
  }
  get childrenState() {
    var e;
    return (e = this.childrenSelectableOptions) != null && e.length ? this.childrenSelectableOptions.length === this.childrenSelectableOptions.filter((t) => t.selected && !t.disabled).length ? "all" : this.childrenSelectableOptions.filter((t) => t.selected && !t.disabled).length ? "some" : "none" : "null";
  }
  /** Référence à l'élément parent `EsTreeContentElement`. */
  get content() {
    return this.closest("es-tree-content");
  }
  get currentIdNamespace() {
    return `esTreeOptGroup-${this.id}`;
  }
  /**
   * Si l'élément parent existe, alors retourne vrai si le premier enfant de l'élément parent est le
   * même que l'élément courant.
   * @returns Une valeur booléenne.
   */
  get isFirstElement() {
    var e;
    return ((e = this.parentElement) == null ? void 0 : e.firstElementChild) === this;
  }
  /**
   * Si l'élément parent existe, alors retourne vrai si le dernier enfant de l'élément parent est
   * l'élément courant.
   * @returns Une valeur booléenne.
   */
  get isLastElement() {
    var e;
    return ((e = this.parentElement) == null ? void 0 : e.lastElementChild) === this;
  }
  get selected() {
    var e;
    return (e = this.tree) != null && e.multiple ? this.childrenState === "all" : this._selected;
  }
  set selected(e) {
    var o;
    const t = this.selected;
    (o = this.tree) != null && o.multiple ? this.toggleChildrenOptions(e) : (this._selected = e, this.dispatchEvent(new Event("change", { bubbles: !0, composed: !0 }))), this.requestUpdate("selected", t);
  }
  /**
   * Basculer la sélection.
   */
  toggle() {
    var e, t, o;
    !this.disabled && !((e = this.group) != null && e.disabled) && ((t = this.tree) != null && t.multiple || (o = this.tree) == null || o.clear(), this.selected = !this.selected, this.dispatchEvent(new Event("change", { bubbles: !0, composed: !0 })));
  }
  /** Référence à l'élément parent `EsTreeElement`. */
  get tree() {
    var e;
    return (e = this.content) == null ? void 0 : e.tree;
  }
  /**
   * Méthode interne du cycle de vie du composant.
   */
  attributeChangedCallback(e, t, o) {
    super.attributeChangedCallback(e, t, o), e === "disabled" && this.dispatchEvent(new CustomEvent("change", { bubbles: !0, composed: !0 }));
  }
  /**
   * Méthode interne du cycle de vie du composant.
   */
  connectedCallback() {
    var e, t, o;
    super.connectedCallback(), (e = this.content) == null || e.addEventListener("change", this.handleContentChange.bind(this)), (t = this.content) == null || t.addEventListener("toggle.es.tree", this.handleContentChange.bind(this)), (o = this.content) == null || o.addEventListener("filter.es.tree", this.handleContentFilter.bind(this));
  }
  /**
   * Méthode interne du cycle de vie du composant.
   */
  disconnectedCallback() {
    var e, t, o;
    (e = this.content) == null || e.removeEventListener("change", this.handleContentChange.bind(this)), (t = this.content) == null || t.removeEventListener("toggle.es.tree", this.handleContentChange.bind(this)), (o = this.content) == null || o.removeEventListener("filter.es.tree", this.handleContentFilter.bind(this)), super.disconnectedCallback();
  }
  /**
   * Permet de basculer entre la sélection et la deselection de toutes les options enfants du composant.
   * Met à jour l'état de sélection de chaque option en fonction de l'état actuel de sélection de toutes les options enfants et de leur état d'activation.
   * Déclenche un événement de changement lorsqu'une option est sélectionnée ou désélectionnée.
   */
  toggleChildrenOptions(e = this.childrenState === "some" || this.childrenState === "none") {
    var t;
    this.disabled || ((t = this.childrenSelectableOptions) == null || t.filter((o) => !o.hidden).forEach((o) => {
      o.selected = e;
    }), this.dispatchEvent(new Event("change", { bubbles: !0, composed: !0 })));
  }
  /**
   * Retourne l'état d'un élément de case à cocher personnalisé en fonction de l'état
   * de ses éléments enfants.
   */
  get checkboxState() {
    var e;
    return (e = this.tree) != null && e.multiple ? this.childrenState === "all" ? "checked" : this.childrenState === "some" ? "partially" : "empty" : this.selected ? "checked" : "empty";
  }
  /** Méthode du rendu du modèle. */
  render() {
    var r, a, d, c, w, v;
    let e = q(this.icons.check);
    e instanceof SVGSVGElement && e.setAttribute("width", "12");
    let t = ee({
      "es_tree-opt-group": !0,
      last: this.isLastElement,
      first: this.isFirstElement
    }), o = ee({
      "no-events": ((r = this.tree) == null ? void 0 : r.allowLabelToSelect) == "none" && ((a = this.tree) == null ? void 0 : a.disallowLabelToExpand)
    });
    return x`

            <div class="${t}">
            
                <div class="es_tree-opt-group-button">
            
                    <button type="button" class="es_tree-opt-group-select-btn"
                        @click="${this.handleSelectClick}"
                        ?disabled="${this.disabled || !((d = this.tree) != null && d.multiple || this.value) || this.uncheckable}" aria-haspopup="true"
                        aria-selected="${this.selected ? "true" : "false"}" 
                        id="${this.currentIdNamespace}SelectButton"
                        aria-labelledby="${this.currentIdNamespace}LabelButton">

                        <!-- Icons -->
                        ${((c = this.tree) != null && c.multiple || this.value) && !this.uncheckable ? x`

                        <es-custom-checkbox type="${(w = this.tree) != null && w.multiple ? "checkbox" : "radio"}" checked="${this.checkboxState}" ?disabled=${this.childrenState === "null"}></es-custom-checkbox>

                        ` : x`
                            <span class="es_tree-opt-group-select-btn-arrow ${this.childrenState === "some" ? "active" : ""}">${q(this.icons.arrowRight)}</span>
                        `}
            
                    </button>

                    <button type="button" class="es_tree-opt-group-label-btn ${o}" tabindex="-1"
                        @click="${this.handleLabelClick}"
                        ?disabled="${this.disabled}"
                        id="${this.currentIdNamespace}LabelButton">
                        <span class="es_tree-opt-group-label">${this.label}</span>
                    </button>
            
                    <button type="button" class="es_tree-opt-group-expand-btn"
                        @click="${this.handleCollapseClick}"
                        aria-labelledby="${this.currentIdNamespace}LabelButton"
                        aria-expanded="${this.expanded ? "true" : "false"}">
                        ${(v = this.childrenOptions) != null && v.length ? x`
                        
                            <span class="es_tree-expand-icon">
                                ${this.expanded ? q(this.icons.less) : q(this.icons.more)}
                            </span>
                            
                            ` : null}
                    </button>
                </div>
            
                <div role="group" aria-labelledby="${this.currentIdNamespace}LabelButton" class="es_tree-opt-group-list ${this.expanded ? "active" : ""}">
                    <slot></slot>
                </div>
            </div>
        `;
  }
  /**
   * Gestion de l'événement click sur le bouton expand/collapse.
   */
  handleCollapseClick(e) {
    e.stopPropagation(), this.expanded = !this.expanded;
  }
  /**
   * Gestion de l’événement `change`.
   */
  handleContentChange() {
    this.requestUpdate(), this["aria-selected"] = this.selected;
  }
  /**
   * Gestion de l’événement `filter.es.tree`.
   */
  handleContentFilter(e) {
    var r;
    let t = (r = this.childrenOptions) == null ? void 0 : r.map((a) => a.label + " " + a.value).join(" ");
    const o = e.detail;
    this.content && o && t ? t.toLowerCase().indexOf(o.toLowerCase()) > -1 ? (this.hidden = !1, this.expanded = !0) : (this.hidden = !0, this.expanded = !1) : (this.hidden = !1, this.expanded = !1);
  }
  /**
   * Gestion de l'événement click sur le bouton label.
   */
  handleLabelClick(e) {
    var t, o;
    e.stopPropagation(), ((t = this.tree) == null ? void 0 : t.allowLabelToSelect) === "all" && (this.tree.multiple || this.value) && this.toggle(), (o = this.tree) != null && o.disallowLabelToExpand || (this.expanded = !this.expanded);
  }
  /**
   * Gestion de l'événement click sur le bouton de sélection.
   */
  handleSelectClick(e) {
    var t;
    e.stopPropagation(), (t = this.tree) != null && t.multiple ? this.toggleChildrenOptions() : this.toggle();
  }
};
m.styles = Se`${D(vt)}`;
L([
  h({ type: Boolean, reflect: !0, attribute: !0 })
], m.prototype, "aria-selected", 2);
L([
  h({ type: Boolean, reflect: !0 })
], m.prototype, "disabled", 1);
L([
  h({ type: Boolean })
], m.prototype, "expanded", 2);
L([
  h()
], m.prototype, "id", 2);
L([
  h()
], m.prototype, "label", 2);
L([
  h({ reflect: !0 })
], m.prototype, "role", 2);
L([
  h({ type: Boolean })
], m.prototype, "uncheckable", 2);
L([
  h()
], m.prototype, "value", 2);
L([
  V()
], m.prototype, "childrenState", 1);
L([
  h({ type: Boolean, attribute: !0, reflect: !0 })
], m.prototype, "selected", 1);
m = L([
  z("es-tree-opt-group")
], m);
const xt = `@charset "UTF-8";*,*:before,*:after{box-sizing:border-box}html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-ms-overflow-style:scrollbar;-webkit-tap-highlight-color:rgba(0,0,0,0)}@-ms-viewport{width:device-width}article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}body{margin:0;font-family:Helvetica,Arial,sans-serif,Segoe UI,Roboto,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol;font-size:.875rem;font-weight:400;line-height:1.5;color:#1e1e1f;text-align:left;background-color:#fff}[tabindex="-1"]:focus{outline:0!important}hr{box-sizing:content-box;height:0;overflow:visible}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5rem}p{margin-top:0;margin-bottom:1rem}abbr[title],abbr[data-original-title]{text-decoration:underline;text-decoration:underline dotted;cursor:help;border-bottom:0}address{margin-bottom:1rem;font-style:normal;line-height:inherit}ol,ul,dl{margin-top:0;margin-bottom:1rem}ol ol,ul ul,ol ul,ul ol{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 1rem}dfn{font-style:italic}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:#3c77bd;text-decoration:none;background-color:transparent;-webkit-text-decoration-skip:objects}a:hover{color:#2a5283;text-decoration:none}.bg-light a:not(.btn){color:#3a72b5}.bg-light a:not(.btn):hover{color:#274e7b}.bg-light-gradient a:not(.btn){color:#3568a6}.bg-light-gradient a:not(.btn):hover{color:#22446c}a:not([href]):not([tabindex]){color:inherit;text-decoration:none}a:not([href]):not([tabindex]):hover,a:not([href]):not([tabindex]):focus{color:inherit;text-decoration:none}a:not([href]):not([tabindex]):focus{outline:0}pre,code,kbd,samp{font-family:monospace,monospace;font-size:1em}pre{margin-top:0;margin-bottom:1rem;overflow:auto;-ms-overflow-style:scrollbar}figure{margin:0 0 1rem}img{vertical-align:middle;border-style:none}svg:not(:root){overflow:hidden}table{border-collapse:collapse}caption{padding-top:.75rem;padding-bottom:.75rem;color:#6c757d;text-align:left;caption-side:bottom}th{text-align:inherit}label{display:inline-block;margin-bottom:.5rem}button{border-radius:0}button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}input,button,select,optgroup,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}button,html [type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{padding:0;border-style:none}input[type=radio],input[type=checkbox]{box-sizing:border-box;padding:0}input[type=date],input[type=time],input[type=datetime-local],input[type=month]{-webkit-appearance:listbox}textarea{overflow:auto;resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output{display:inline-block}summary{display:list-item;cursor:pointer}template{display:none}[hidden]{display:none!important}.form-control{display:flex;justify-content:space-between;width:100%;padding:.375rem .75rem;font-size:.875rem;line-height:1.5;color:#505154;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;text-align:left;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media screen and (prefers-reduced-motion: reduce){.form-control{transition:none}}.form-control::-ms-expand{background-color:transparent;border:0}.form-control:focus{color:#505154;background-color:#fff;border-color:#3c77bd;outline:0;box-shadow:"none"}.form-control::placeholder{color:#6c757d;opacity:1}.form-control:disabled,.form-control[readonly]{background-color:#f3f4f4;opacity:1}.es_tree-overlay{background-color:#fff;border-color:#3c77bd;border-style:solid;border-width:1px;position:relative;width:100%}.es_tree-overlay .es_tree-overlay-content{overflow:auto;max-height:100%;padding:2rem}.es_tree-overlay .es_tree-overlay-content .es_tree-filter-input{margin-bottom:1rem}.es_tree-overlay[data-orientation=up]{border-top-left-radius:.25rem;border-top-right-radius:.25rem;box-shadow:#00000026 0 -1rem 1rem -.5rem}.es_tree-overlay[data-orientation=up] .es_tree-overlay-divider{bottom:-1px}.es_tree-overlay[data-orientation=down]{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem;box-shadow:#00000026 0 1rem 1rem -.5rem}.es_tree-overlay[data-orientation=down] .es_tree-overlay-divider{top:-1px}.es_tree-overlay[data-origin-x=start] .es_tree-overlay-divider{left:0}.es_tree-overlay[data-origin-x=end] .es_tree-overlay-divider{right:0}
`;
var Et = Object.defineProperty, _t = Object.getOwnPropertyDescriptor, ce = (e, t, o, r) => {
  for (var a = r > 1 ? void 0 : r ? _t(t, o) : t, d = e.length - 1, c; d >= 0; d--)
    (c = e[d]) && (a = (r ? c(t, o, a) : c(a)) || a);
  return r && a && Et(t, o, a), a;
};
let N = class extends B {
  constructor() {
    super(), this._hidden = !0, this.filter = "", this.inputRef = ae(), this.focusTrapRef = ae();
    let e = 0;
    this.addEventListener("change", () => {
      clearTimeout(e), e = setTimeout(() => {
        var t;
        (t = this.tree) == null || t.dispatchEvent(new CustomEvent("change", { bubbles: !0, composed: !0 })), this.requestUpdate();
      }, 10);
    });
  }
  get tree() {
    return this._tree;
  }
  set tree(e) {
    const t = this.tree;
    this._tree = e, this.requestUpdate("tree", t), this.dispatchEvent(new CustomEvent("treeconnected.es.tree-content", { bubbles: !0, composed: !0 }));
  }
  /**
   * Retourne la valeur de la variable privée `_hidden`.
   * @returns La valeur de la propriété masquée.
   */
  get hidden() {
    return this._hidden;
  }
  /**
   * Si la valeur est `true`, l'arborescence est fermée et le focus est défini sur le bouton. Si la
   * valeur est `false`, l'arborescence est ouverte et le focus est défini sur l'entrée
   * @param value - La valeur de la propriété.
   */
  set hidden(e) {
    var t, o, r, a;
    e ? ((t = this.tree) == null || t.dispatchEvent(new CustomEvent("close.es.tree", { bubbles: !0, composed: !0 })), (r = (o = this.tree) == null ? void 0 : o.buttonRef.value) == null || r.focus()) : ((a = this.tree) == null || a.dispatchEvent(new CustomEvent("open.es.tree", { bubbles: !0, composed: !0 })), setTimeout(() => {
      var d;
      (d = this.focusTrapRef.value) == null || d.focusFirstElement();
    }, 100)), this._hidden = e, e ? this.setAttribute("hidden", "") : this.removeAttribute("hidden");
  }
  /**
   * Retourne l'élément utilisé pour le calcul de la position relative.
   */
  get positionRelativeToElement() {
    if (this.positionRelativeTo)
      return document.querySelector(this.positionRelativeTo);
  }
  /** Gestion de l'événement `close` de l'overlay.  */
  onCloseHandle() {
    this.hidden = !0;
  }
  /** Gestion de l'événement `keydown` sur le contenu. */
  onContentKeydown(e) {
    var R, W, X, G, P, H, te, K, Z, J, I;
    let t = e.target;
    if (!t || !(t instanceof HTMLElement))
      return;
    let o = t.parentElement, r = Array.from((o == null ? void 0 : o.children) || []).filter(($) => ($ instanceof m || $ instanceof _) && !$.disabled), a = r.findIndex(($) => $ === t), d = a + 1, c = a - 1, w = r[d] ? r[d] : r[0], v = r[c] ? r[c] : r[r.length - 1];
    const k = 'button:not([disabled]):not([tabindex^="-"])';
    switch (e.key) {
      case "Escape":
        this.hidden = !0;
        break;
      case "ArrowDown":
        e.preventDefault(), (W = (R = w.shadowRoot) == null ? void 0 : R.querySelector(k)) == null || W.focus();
        break;
      case "ArrowUp":
        e.preventDefault(), (G = (X = v.shadowRoot) == null ? void 0 : X.querySelector(k)) == null || G.focus();
        break;
      case "ArrowRight":
        e.preventDefault(), t instanceof m && (t.expanded ? (te = (H = (P = t.firstElementChild) == null ? void 0 : P.shadowRoot) == null ? void 0 : H.querySelector(k)) == null || te.focus() : t.expanded = !0);
        break;
      case "ArrowLeft":
        e.preventDefault(), t instanceof m ? t.expanded ? t.expanded = !1 : t.parentElement && t.parentElement instanceof m && ((Z = (K = t.parentElement.shadowRoot) == null ? void 0 : K.querySelector(k)) == null || Z.focus()) : t instanceof _ && t.group && ((I = (J = t.group.shadowRoot) == null ? void 0 : J.querySelector(k)) == null || I.focus());
        break;
      case "Tab":
        e.preventDefault();
        break;
    }
  }
  /** Gestion de l'émission de l’événement `filter.es.tree` */
  onFilterInput(e) {
    var t;
    e.target && e.target instanceof HTMLInputElement && (this.filter = e.target.value, (t = this.tree) == null || t.dispatchEvent(new CustomEvent("filter.es.tree", { detail: this.filter, bubbles: !0, composed: !0 })), this.dispatchEvent(new CustomEvent("filter.es.tree", { detail: this.filter, bubbles: !0, composed: !0 })), this.requestUpdate());
  }
  /** Gestion de l'émission de l’événement `orientationChange.es.tree` */
  onOrientationChange(e) {
    var t;
    (t = this.tree) == null || t.dispatchEvent(new CustomEvent("orientationChange.es.tree", { bubbles: !0, composed: !0, detail: e.detail }));
  }
  /** Gestion de l'émission de l’événement `originXChange.es.tree` */
  onOriginXChange(e) {
    var t;
    (t = this.tree) == null || t.dispatchEvent(new CustomEvent("originXChange.es.tree", { bubbles: !0, composed: !0, detail: e.detail }));
  }
  /** Méthode de rendu du modèle. */
  render() {
    var e, t, o, r, a;
    return x`
        <es-overlay 
            .connectedTo="${(e = this.tree) == null ? void 0 : e.buttonRef.value}" 
            ?show="${!this.hidden}" 
            .overlaySize="${{ width: "auto" }}"
            @close.es.overlay="${this.onCloseHandle}"
            @orientationChange.es.overlay="${this.onOrientationChange}"
            @originXChange.es.overlay="${this.onOriginXChange}"
            backdropStyle="transparent"
            .positionRelativeTo="${this.positionRelativeToElement}">

            <div class="es_tree-overlay" 
                    data-orientation="${Y(this._orientation)}" 
                    data-origin-x="${Y(this._originX)}"
                    >
                
                    <div class="es_tree-overlay-content">
                        <focus-trap ${le(this.focusTrapRef)}>

                            ${(t = this.tree) != null && t.showRefiner ? x`
                            <input type="text" class="es_tree-filter-input form-control" 
                            placeholder="Filter" 
                            @input="${this.onFilterInput}"
                            ${le(this.inputRef)}
                            >
                            ` : null}

                            <div role="tree" class="es_tree-results" aria-labelledby="${Y((o = this.tree) == null ? void 0 : o.id)}" @keydown=${this.onContentKeydown}>
                                <slot></slot>
                            </div>

                            ${!((r = this.tree) != null && r.options.length) || !((a = this.tree) != null && a.filteredOptions.length) ? x`<slot name="noResults"></slot>` : null}

                            </focus-trap>
                    </div>
                </div>
            
            </es-overlay>
       
       `;
  }
  firstUpdated(e) {
    this.dispatchEvent(new CustomEvent("firstupdated.es.tree-content", { bubbles: !0, composed: !0 }));
  }
};
N.styles = D(xt);
ce([
  V()
], N.prototype, "_hidden", 2);
ce([
  h()
], N.prototype, "positionRelativeTo", 2);
ce([
  h()
], N.prototype, "tree", 1);
N = ce([
  z("es-tree-content")
], N);
export {
  U as EsCustomCheckboxElement,
  S as EsOverlayElement,
  C as EsTagsInputElement,
  N as EsTreeContentElement,
  g as EsTreeElement,
  m as EsTreeOptGroupElement,
  _ as EsTreeOptionElement
};
